webpackJsonp([1],{

/***/ "3jmS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXhP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mjxm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ddc7ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("Om6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a0bff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("JAIY")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2c09f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("nSix")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-1d2c09f7"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a4f08ab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("xJNA")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-0a4f08ab"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19b17162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("Mjxm")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67fad68a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("lsaJ")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b08f99d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){_vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("fbGF")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45475472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("HXhP")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be6e2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("OT+5")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1538bbbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("OLkq")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688d3493","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})})):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("hxKv")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07dfdf84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("hLNX")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutubeOrOlympics: function isYoutubeOrOlympics() {
      return this.videoURL.search('youtube') !== -1 || this.videoURL.search('olympic') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70c81c71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutubeOrOlympics)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("3jmS")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e710b5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("o4GY")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-4e710b5e"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399a74da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("hIWI")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d498b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("WpSr")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56a5686a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("l+EB")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Olympic Review - Issue 126",
  "shortTitle": "",
  "description": "",
  "width": 719,
  "height": 890,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "http://olympicreview.touchlines.com/126"
  }, {
    "code": "FR",
    "text": "French",
    "href": "http://revueolympique.touchlines.com/126"
  }],
  "basePath": "/126",
  // "basePath": "",
  "companyLogo": "1-logo-1.png",
  "publishURL": "http://olympic-review.s3-website-eu-west-1.amazonaws.com/126/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 1-title-1\" style=\"top:-13px;left:-18px;\" src=\"/126/static/_content/1-title-1.png\"/>\n      <img class=\"abs halfScale 1-title-2\" style=\"top:130px;left:234px;\" src=\"/126/static/_content/1-title-2.png\"/>\n      <img class=\"abs halfScale 1-header\" style=\"top:15px;left:240px;\" src=\"/126/static/_content/1-header-1.png\"/>\n      <img class=\"abs halfScale 1-date\" style=\"top:162px;left:532px;\" src=\"/126/static/_content/1-date-issue-1.png\"/>\n      \n      <img class=\"abs halfScale 1-subtitle\" style=\"top:244px;left:34px;\" src=\"/126/static/_content/1-subtitle-1.png\"/>\n      <img class=\"abs halfScale 1-subtitle\" style=\"top:299px;left:33px;\" src=\"/126/static/_content/1-subtext-1.png\"/>\n      <img class=\"abs halfScale 1-caption\" style=\"top:403px;left:566px;\" src=\"/126/static/_content/1-text-1.png\"/>\n      <img class=\"abs halfScale 1-caption\" style=\"top:459px;left:566px;\" src=\"/126/static/_content/1-text-2.png\"/>\n      <img class=\"abs halfScale 1-caption\" style=\"top:517px;left:566px;\" src=\"/126/static/_content/1-text-3.png\"/>\n      <img class=\"abs halfScale 1-logo\" style=\"top:831px;left:15px;\" src=\"/126/static/_content/1-logo-1.png\"/>\n      <img class=\"abs halfScale 1-link\" style=\"top:863px;left:633px;\" src=\"/126/static/_content/1-link-1.png\"/>\n\n      <div class=\"contentLink\" style=\"top:859px;left:627px;width:80px;height:18px\">\n        <a href=\"https://olympics.com/\" target=\"_blank\"></a>\n      </div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(cOf(\"1-title-1\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"1-title-2\"), 0.6, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"1-header\"), 0.6, {opacity:0, x:35}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n          .fromTo(cOf(\"1-date\"), 0.6, {opacity:0, y:50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.5)\n          .staggerFromTo(cOf(\"1-subtitle\"), 0.7, {opacity:0, x:40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 1.7)\n          .staggerFromTo(cOf(\"1-caption\"), 0.6, {opacity:0, x:-40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.9);\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Official Publication of the Olympic Movement TM  REVIEW  June 2026 Number 126  Dakar 2026 As the ﬁrst Olympic sporting event to be held in Africa, the Dakar 2026 Youth Olympic Games will inspire a new generation and create lasting opportunities through sport We explore the cultural and historical heritage awaiting visitors to Senegal Athlete Role Models reveal how they will support the YOG athletes Local photographers capture Dakar’s vibrant sports culture and daily life  olympics.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 4-title\" style=\"top:114px;left:44px;\" src=\"/126/static/_content/4-title-1.png\"/>\n      <img class=\"abs halfScale 4-sub\" style=\"top:178px;left:43px;\" src=\"/126/static/_content/4-sub-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(6);\" style=\"top:363px; left:50px; width:86px; height:90px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(16);\" style=\"top:312px; left:218px; width:140px; height:129px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(8);\" style=\"top:538px; left:90px; width:158px; height:127px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(30);\" style=\"top:745px; left:294px; width:262px; height:111px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.fromTo(cOf(\"4-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"4-sub\"), 0.9, {opacity:0, y:20}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "4  Contents  CONTENTS  OFFICIAL PUBLICATION OF THE OLYMPIC MOVEMENT JUNE 2026  16  6  DAKAR 2026 OVERVIEW  FOREWORD  By IOC President Kirsty Coventry.  Ahead of Dakar 2026, we look at the sports programme, where the action will take place and the lasting impact the event will leave.  8  IOC PRESIDENT INTERVIEW  IOC President Kirsty Coventry discusses why the upcoming Youth Olympic Games are the perfect opportunity to showcase African culture and spirit.  30  DAKAR 2026 LEARNING ACADEMY  An educational programme promises to not only support the development of Dakar 2026, but also to unlock the next generation of sports event professionals."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(38);\" style=\"top:155px; left:182px;; width:129px; height:125px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(48);\" style=\"top:307px; left:50px; width:235px; height:105px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(62);\" style=\"top:245px; left:352px; width:149px; height:105px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(64);\" style=\"top:597px; left:326px; width:175px; height:113px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(78);\" style=\"top:744px; left:51px; width:105px; height:113px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(80);\" style=\"top:744px; left:202px; width:137px; height:113px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(82);\" style=\"top:744px; left:366px; width:75px; height:113px;\"></div>\n\n      <div class=\"addContentLink\" style=\"top:580px;left:530px;width:101px;height:10px\">\n        <a href=\"https://olympics.com/ioc\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:588px;left:530px;width:108px;height:8px\">\n        <a href=\"mailto:olympicreview@olympic.org\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax();\n        }\n\n        function onPageLeave() {\n          pg5Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Olympic Review  5  Issue 126  EXECUTIVE BOARD  38  President Kirsty Coventry Vice-Presidents Nawal El Moutawakel, Gerardo Werthein, Baron Pierre-Olivier Beckers-Vieujant, Juan Antonio Samaranch Members HRH Prince Feisal Al Hussein, Mikaela Cojuangco Jaworski, Lingwei Li, Spyros Capralos, Kristin Kloster, Octavian Morariu, Ingmar De Vos, Pau Gasol Sáez, Neven Ilic, Jae Youl Kim  A CULTURAL SHOWCASE  Célia Cuordifede examines the cultural and historical heritage that awaits those visiting Senegal for the Youth Olympic Games.  OLYMPIC REVIEW  62  BEYOND THE RINGS  48  Rémy Rioux highlights how sport can be a driver for education, inclusion and peace.  THROUGH THE LENS  A pictorial look at how Dakar’s vibrant sporting culture is woven into everyday life, captured by local photographers Sidy Talla and Badara Preira.  Corporate Communications & Public Affairs Director Christian Klaue Editor-in-Chief Katharine Mann Deputy Editor & French Edition Lucile Tonnerre Spanish Edition Dolores Blázquez Production Agency Touchline Production Michael Stoneman, Glyn Wilmshurst, John Murray, Sam Price, Conor Ketley Design Liz Rankin, Shyama Rajani, Apostolis Tatasopoulos, Jen Thich Image retouching Liz Rankin Translation Aurélien Sagnier, Héctor Lopez Conceiro, Indira Akanni, Ros Schwartz, Laura Bennet Proofreading Cameron Harvey-Piper, Will Fulford-Jones ISSN: 0377-192X Printed in the UK  IMAGES Cover image: Sidy Talla Inside: IOC; IOC/Greg Martin; IOC/Quinton Meyer; IOC/Ubald Rutar; IOC/Muhammed Camara; IOC/Badara Preira; IOC/Nelson Chavez; IOC/Giulio Locatelli; IOC/Richard Juilliart; IOC/Benoît Fontaine; IOC/Roberto González Espeso; Dakar 2026 Youth Olympic Games Organising Committee; Olympics.com; Getty Images; Sidy Talla; Rémy Rioux; Salah-Eddine Gakou; Steve Lorcy; Penny Bird; Blessing Oborududu; Jamila Lunkuse  CONTACTS Please contact us at: Olympic Review, IOC Corporate Communications & Public Affairs Department, Maison Olympique, 1007 Lausanne, Switzerland website: www.olympics.com/ioc email: olympicreview@olympic.org tel: +41 (0)21 621 6111  ATHLETE ROLE MODELS  Athletes from across the sporting world will act as mentors to young competitors at Dakar 2026, continuing a Youth Olympic Games tradition.  78  80  82  Book reviews from the IOC Olympic Studies Centre.  Olympians and figures from the Olympic Movement who have passed away.  Facts and figures about Dakar 2026.  OLYMPIC STUDIES  OBITUARIES  THE LAST WORD  Olympic Review is published by the International Olympic Committee. The articles published in Olympic Review do not necessarily reflect the opinions of the International Olympic Committee. No articles may be reproduced without the permission of the IOC Corporate Communications & Public Affairs Department. The Olympic terminology (in particular Olympic™, Olympics™ and Olympic Games™) and other Olympic Properties are registered trademarks (TM) owned by the IOC. For further information on the protection of the Olympic Properties, please consult the website: olympics.com.  All information correct at the time of going to press  64  Olympic Review uses PEFC-certified paper stock sourced from sustainably managed forests."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 7-title\" style=\"top:97px;left:46px;\" src=\"/126/static/_content/7-title-1.png\"/>\n      <div id=\"7-sig\" class=\"abs noOverflow\" style=\"top:762px; left:474px; height:69px; width:100px; background-color:#ffffff\"></div>\n\n      <div class=\"addContentLink\" style=\"top:338px;left:273px;width:57px;height:13px;\">\n        <a href=\"https://www.olympics.com/fr/olympic-games/dakar-2026\" target=\"_blank\"></a>\n      </div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax();\n          pg7Anim.fromTo(cOf(\"7-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(idOf(\"7-sig\"), 0.9, {width:155,x:0}, {width: 0,x:167, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg7Anim.stop();         \n          removeContentLinks();\n        }\n      ",
    "searchText": "Olympic Review  7  Issue 126  FOREWORD BY KiRSTY COVENTRY A  Dakar will provide a stunning setting for the fourth edition of the Summer Youth Olympic Games.  few months from now, the Olympic Movement will arrive in Dakar, Senegal, for a truly historic moment: the ﬁrst Olympic sporting competition ever held on African soil. As a proud African and a proud Olympian, I could not be more excited. Dakar 2026 will be a celebration of sport, youth and possibility. Under the motto “Africa welcomes, Dakar celebrates”, these Youth Olympic Games (YOG) will show the world the energy, creativity and ambition of a new generation. But what makes these Games so special is not only the sport – it is what sport makes possible. The YOG give young athletes the chance to compete, to grow and to experience the Olympic values at an important moment in their lives. For many, this will be their ﬁrst experience of the  Olympic Movement. They will make friendships across cultures, discover new opportunities and learn lessons that stay with them long after the Games are over. That spirit can already be felt across Senegal. Dakar 2026 is bringing together sport, education and culture in a way that feels authentic to the country and to the continent. From music and art to community celebrations and youth programmes, these Games are proudly shaped by Senegal’s identity and by the creativity of its young people. The sporting programme itself reﬂects this approach. Alongside the competition sports, young athletes and visitors will also have the opportunity to discover engagement sports that connect with new audiences and encourage participation, discovery and fun. At the same time, Dakar 2026 is already creating opportunities beyond the ﬁeld of play. Through initiatives like the Learning Academy, young professionals from Senegal and across Africa are gaining hands-on experience in delivering major sporting events. Education and valuesbased programmes are also reaching hundreds of thousands of young people, helping them build conﬁdence, leadership skills and a sense of community. This is the true legacy of Dakar 2026. In the pages that follow, you will discover some of the people and projects bringing these Games to life: the athletes inspiring the next generation, the young leaders helping shape the future, and the artists and photographers capturing the spirit of Dakar. I hope these stories leave you with the same feeling they leave with me: excitement for what is to come, and conﬁdence in what these Games can achieve for young people in Africa and around the world. ■  Kirsty Coventry, IOC President"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 8-quote-box\" style=\"top:144px;left:61px;\" src=\"/126/static/_content/8-quote-box-1.png\"/>\n      <img class=\"abs halfScaleC 8-quote-text\" style=\"top:135px;left:-176px;\" src=\"/126/static/_content/8-quote-text-1.png\"/>\n      <img class=\"abs halfScaleC 8-quote-icon\" style=\"top:78px;left:65px;\" src=\"/126/static/_content/8-quote-icon-1.png\"/>\n      <img class=\"abs halfScaleC 8-sub\" style=\"top:600px;left:25px;\" src=\"/126/static/_content/8-sub-1.png\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim.fromTo(cOf(\"8-quote-box\"), 0.9, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"8-quote-icon\"), 0.9, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.3)\n          .fromTo(cOf(\"8-quote-text\"), 0.9, {opacity:0, x: 25}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.5)\n          .fromTo(cOf(\"8-sub\"), 0.9, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6);\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n        }\n      ",
    "searchText": "8  IOC President interview  “  A wonderful experience for all young athletes IOC PRESIDENT KIRSTY COVENTRY BELIEVES THE DAKAR 2026 YOUTH OLYMPIC GAMES ARE A PERFECT OPPORTUNITY TO SHOWCASE AFRICAN CULTURE AND SPIRIT, AND BREAK STEREOTYPES. BY STEVE WILSON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"abs halfScale 9-quote-box\" style=\"top:144px;left:-658px;\" src=\"/126/static/_content/9-quote-box-1.png\"/>\n      <img class=\"abs halfScaleC 9-quote-icon\" style=\"top:511px;left:495px;\" src=\"/126/static/_content/9-quote-icon-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax();\n          pg9Anim.fromTo(cOf(\"9-quote-box\"), 0.9, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"9-quote-icon\"), 0.9, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop();\n        }\n      ",
    "searchText": "Olympic Review  9  Issue 126  Ó Kirsty Coventry chaired the Dakar 2026 Coordination Commission until her election as IOC President."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "10  IOC President interview  1  K  irsty Coventry already knows her tears will ﬂow. When 31 October 2026 arrives, no one will feel more pride and emotion than the International Olympic Committee (IOC) President. The occasion will be the Opening Ceremony of the Dakar 2026 Youth Olympic Games (YOG) – the ﬁrst Olympic sporting event to be held in Africa. “I’m going to be so excited,” says President Coventry, “and hopefully not crying too much.” For the IOC leader, the Games offer Senegal and Africa the chance to shatter stereotypes and showcase the best of what the continent has to offer. She speaks from experience. President Coventry grew up in Harare, Zimbabwe, swimming in unheated outdoor pools in winter conditions and going on to become Africa’s most decorated Olympian. As an IOC Member, she chaired the  Coordination Commission (CoCom) for Dakar 2026 from 2018 until her election last year as the ﬁrst female and ﬁrst African President of the IOC.  Defying expectations “I think people underestimate Africa,” says President Coventry. “I’m so excited for people to get to Dakar and be disappointed that they’re not going to be disappointed. I’m excited for people to get there and be like, ‘Wow, I didn’t expect that – this is way better than I thought.’ “Those automatic stereotypes are very much still there. I would love to break some of those down. But most of all, I just want everybody to experience the true African culture and spirit.” In the eight years since Dakar was awarded the Games, President Coventry has witnessed a tremendous transformation as the Senegalese capital gears up to host  the world’s best young athletes for the fourth summer edition of the YOG. “You watch all the venues being built up, almost brick by brick,” she says. “And then, suddenly, it gets to a point where you’re like, ‘Oh my gosh – that’s beautiful.’ You suddenly see it for the reality that it will be.” Even her own team, President Coventry says, was surprised when they arrived in Dakar for those ﬁrst CoCom meetings, expressing the common reaction of: “Wow, this is not what we expected at all.” The response was similar among IOC visitors who attended the Dakar en Jeux festival, which features sport and cultural activities and has been held each year in the run-up to the YOG. “They wondered, ‘How did you mobilise all these people and these young people?’” says President Coventry. “I said: ‘This is Africa. This is what we do. This is how we celebrate’.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  11  Issue 126  2  2  A personal journey The build-up to 2026 has taken place while President Coventry has taken her own journey to the very top of the Olympic Movement. She was Chair of the IOC Athletes’ Commission and Zimbabwe’s Minister of Sport in 2018 when Dakar was awarded the YOG hosting rights at the 133rd IOC Session – which took place in Buenos Aires during the previous YOG. At the same Session, she was also appointed Chair of the Dakar 2026 CoCom. The Dakar YOG were originally due to be held in 2022, but they were later postponed until 2026 due to the impact of the COVID-19 pandemic. Following her historic election as IOC President in March 2025, Coventry handed over the CoCom Chair’s role to IOC Member Humphrey Kayange of Kenya. President Coventry has also followed the changes at the national level in Senegal. Bassirou Diomaye Faye was elected President in 2024, succeeding Macky Sall and  becoming Africa’s youngest elected leader at the age of 44. “It’s incredible to see the new President of the country,” says President Coventry. “The emphasis that he’s placing on sport and the importance that he’s placing on sport for developing young people, upgrading people with new skills and giving opportunity, is very exciting.” President Coventry saw the new dynamics up close when she travelled to Dakar last year for her last CoCom meeting as Chair. “I felt the change in the environment,” she says. “The excitement around the opportunity that these Youth Olympic Games will bring to Senegal, but also to Africa, is really being understood in a way that I don’t know if it has been before. It’s been nice to see the acknowledgement of the role that sport can play and what that looks like.”  1 Beach handball will be one of 25 competition sports at Dakar 2026. 2 The annual Dakar en Jeux festival has built excitement ahead of the YOG.  A Games for a continent Dakar 2026 has been promoted as a Games not only for Senegal but for the whole of Africa. But can they truly represent such a vast and diverse continent? Yes, says President Coventry. She grew up in an English-speaking country in southern Africa and believes that these Games – held in a Francophone nation of West Africa – can unite the entire continent. She has frequently cited the African philosophy of “ubuntu” – or “I am because we are”. “There are so many traditional aspects that the Senegalese people have that we also have in Zimbabwe,” says President Coventry. “Yes, it’s different, but it’s part of the same family. When people come and visit Senegal, they’ll get a taste of the diversity that Africa has, and the richness of culture and heritage that we have. I do think it will do an incredible job of representing the continent 100 per cent.” The YOG, of course, will be about the 2,700 or so young athletes aged 14–17 competing, many for the ﬁrst time, in a global event. As an Olympian from Africa, President Coventry can empathise with the challenges faced by young African athletes in preparing to make their breakthrough in Dakar."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 12-quote\" style=\"top:471px;left:-41px;\" src=\"/126/static/_content/12-quote-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim.fromTo(cOf(\"12-quote\"), 0.9, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n        }\n      ",
    "searchText": "12  IOC President interview  1  1  “You will see hungry athletes who want to prove a point, who want to showcase how good they can be” IOC PRESIDENT KIRSTY COVENTRY  As a young girl in Harare, President Coventry was inspired to become an Olympic athlete when she watched the Barcelona 1992 Olympic Games on television. She participated in several sports as a child, eventually focusing on swimming and launching her own Olympic career. “Growing up in Zimbabwe, we didn’t really know any different,” she says. “Swimming in winter in an unheated and uncovered pool – this is what we had to do. We just made a plan that we swam for as long as we could, and then we ran cross-country and played hockey, and made Plan B just to stay ﬁt.”  Coventry received a scholarship to attend Auburn University in the USA, where she won several national swimming championships. She went on to compete in ﬁve Olympic Games, winning two gold medals and seven in all, a record for an African athlete. “It wasn’t until I got to the US where I was like, ‘Wait, not everyone trains like this in a run-down pool?’” she says. “And I think what we will see in Dakar is the incredible talent that Africa has that needs extra support in order to realise the potential that’s there.”  The athletes’ legacy Based on her own experiences, President Coventry knows that African athletes will be driven to prove themselves on a world stage. “I know from just who I am that we are very hungry athletes,” she says. “We want to do well. We want to do better. We strive to try to be the best that we can with any little bit of opportunity that we’re given. “I think you will see that in Dakar. I think you will see hungry athletes who want to  prove a point, who want to showcase how good they can be. And when they’re given the opportunity to do that, they will take that with both hands and they will run with it.” The hope is that some of those African athletes will go on to excel at future Olympic Games – at LA28 or, more likely, Brisbane 2032. “If we can look back and point out a number of young athletes who were in Dakar who are then making ﬁnals or winning medals in Brisbane, then I think we can look back at the legacy and the success of that legacy and measure it,” says President Coventry. The IOC leader also hopes that the young athletes from richer parts of the world will come to understand and appreciate the struggles faced by African athletes, such as a lack of facilities and funding. “I hope they think, ‘Wow, we’re getting these kinds of facilities daily and these athletes have to deal with a different reality – but look at what they can achieve. Let’s not take things for granted. Let’s put things into perspective.’ “And, for me, if athletes globally can walk away being open to experiencing something new, something different, then I think that’s also a success. They could think, ‘We didn’t expect this level of great competition and we didn't expect these incredible venues to be here in Africa. But look at what we’ve experienced and look at what has been showcased’.”  The road ahead Staging the YOG in Africa has again raised the prospect of the Olympic Games being held on the continent for the ﬁrst time. South Africa is among multiple countries around the world expressing interest in hosting the Games in 2036 or 2040. President Coventry cautions against expectations and makes no promises. “I think there are a number of parts of our world that have never hosted that would greatly beneﬁt from hosting the Olympic Games, and I look forward to ﬁguring out how we do that. How do we open the Olympic  1 With seven medals, Kirsty Coventry is Africa’s most decorated Olympian. 2 Kenyan steeplechaser Fancy Cherono in action at the Buenos Aires 2018 YOG."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 14-quote\" style=\"top:491px;left:-34px;\" src=\"/126/static/_content/14-quote-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim.fromTo(cOf(\"14-quote\"), 0.9, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);\n        }\n\n        function onPageLeave() {\n          pg14Anim.stop();\n        }\n      ",
    "searchText": "14  IOC President interview  1 1  “Dakar will be wonderful. It’ll be a wonderful experience for all those young athletes” IOC PRESIDENT KIRSTY COVENTRY Games to new regions so that they do become a reality?” President Coventry says there is no timeline for a potential Olympic Games in Africa, stressing that the conditions and timing must be right. “It has to be done in a conscious way that is also authentic,” she says. “It’s not pushing something. It’s not forcing something because that’s when you don’t have any stability, you don’t have any sustainability. You don’t want to end up with white elephants, right?  “If we’re going to encourage new countries or regions, it has to be a part of their long-term development and their long-term goals in order for it to truly be successful. It has to be done where the legacy is not going to be negative.” Dakar 2026 comes at a time when the IOC is reviewing the future of the YOG as part of President Coventry’s “Fit for the Future” agenda. Changes have already been made to the sports programme and other elements of the Dakar Games, but much deeper changes could be in store for future editions of the YOG. “We have to really analyse that if we want the YOG to continue, what is it doing?” says President Coventry. “What is the impact? What is the goal? Is it high performance? Is it education? Right now, it’s a bit of a mix and is not necessarily the way everyone wants it to be. “Dakar will be wonderful. It’ll be a wonderful experience for all those young  athletes. I do think they will walk away hopefully being very inspired by the Olympic values. But moving forward, we really do need to re-evaluate what the YOG is and what it should be.” Meantime, one thing is certain: with Dakar 2026’s Opening Ceremony approaching, President Coventry already knows how much the moment will mean to her on a deeply personal level. “I’m going to get very emotional. There will be tissues on hand for sure.” ■  1 South Africa hosted the 2010 FIFA World Cup."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "omegawatches.com  OFFICIAL TIMEKEEPER The clocks are counting down to the Youth Olympic Games Dakar 0DUNLQJ WKH ƸUVW ,2& VSRUWLQJ HYHQW WR EH KRVWHG LQ $IULFD WKH FRPSHWLWLRQ ZLOO DOVR LJQLWH WKH ƸUVW WKULOOLQJ KRXUV RI VR PDQ\ DWKOHWLFFDUHHUV7RVHUYHWKLVKLVWRULFRFFDVLRQDV2IƸFLDO7LPHNHHSHU 20(*$ ZLOO FRQWLQXH LWV 2O\PSLF *DPHV OHJDF\ EULQJLQJ  \HDUV RIH[SHULHQFHH[SHUWLVHDQGWHFKQLFDOHYROXWLRQ7KHPRVWUHQRZQHG VWDQGDUGRISUHFLVLRQIRUWKHVHWKRXVDQGVRI\RXQJFRPSHWLWRUVZKR UHSUHVHQWWKHQH[WJHQHUDWLRQRIH[FHOOHQFH"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 16-title\" style=\"top:104px;left:42px;\" src=\"/126/static/_content/16-title-1.png\"/>\n      <img class=\"abs halfScale 16-title\" style=\"top:250px;left:44px;\" src=\"/126/static/_content/16-title-2.png\"/>\n      <img class=\"abs halfScale 16-sub\" style=\"top:402px;left:43px;\" src=\"/126/static/_content/16-sub-1.png\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim.staggerFromTo(cOf(\"16-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1)\n          .fromTo(cOf(\"16-sub\"), 0.9, {opacity:0, y:35}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop();\n        }\n      ",
    "searchText": "16  Feature: Dakar 2026 Overview  A HiSTORiC MOMENT THE DAKAR 2026 YOUTH OLYMPIC GAMES WILL MARK THE FIRST OLYMPIC EVENT HELD ON AFRICAN SOIL, WITH ORGANISERS HOPING THE GAMES CAN INSPIRE A NEW GENERATION AND CREATE LASTING OPPORTUNITIES THROUGH SPORT. BY MICHAEL STONEMAN  Beach wrestling will make its Olympic debut at Dakar 2026."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "18  Dakar 2026 preview  C  ommuters at the Colobane train station in Dakar pass each day beneath a newly painted mural that is difficult to miss. Rising seven metres high alongside a busy footbridge, it offers a colourful reminder of both the upcoming Youth Olympic Games (YOG) and the young people they are set to inspire. The eye-catching mural, created by talented street artists Zeinixx and Kathrina Rupit, brings together three generations of Senegalese athletes. Two of them are instantly recognisable to those who look up from their daily commute. Trailblazer Julie Marie Gomis has been a role model in the country since 1976, when she became the ﬁrst Senegalese woman to compete at an edition of the Olympic Games. Combé Seck, meanwhile, represents a more recent chapter, with the sprint canoeist having carried the national ﬂag at the Opening Ceremony of Paris 2024. And then there is Tening Faye. While her face may not be as recognisable as those of Gomis and Seck, the teenager symbolises the exciting future of sport in Senegal. It is a future that will experience a deﬁning moment when the country hosts the Dakar 2026 YOG, becoming the ﬁrst African nation to stage an Olympic sporting event. 1 In 2025, at the age of 15, Faye became the ﬁrst Senegalese athlete to win a medal at the World Taekwondo Cadet Championships, clinching bronze in the -44kg category. It was her ﬁrst experience of competition at that level. “I was very emotional,” she says. “It was my very ﬁrst international competition, and I won the bronze medal. I’m so proud.” Faye’s historic achievement came just two years after taking up taekwondo, having been inspired by a friend to try the sport. “[My friend] would walk past our house on her way to training, and every time, I wanted to follow her,” she explains. “That's when my mother spoke to the coach. That's where my career began. It was very difficult at the beginning because I hadn’t yet mastered the kicks. But the coach helped me improve.”  1 Tening Faye made history for Senegal at the World Taekwondo Cadet Championships. 2 The Brevet olympique, civique et sportif programme aims to reach 900,000 children. 3 Participants get active during the annual Dakar en Jeux festival.  1  Faye’s rapid progress saw her standing on the podium at the World Taekwondo Cadet Championships. Now, she is aiming to do the same on home soil at the YOG, with her ambition reﬂecting a wider sense of anticipation across Senegal and Africa as this historic moment approaches.  “A statement of belief” “When the International Olympic Committee selected Senegal in 2018, it placed its trust not only in a country, but in an entire continent,” says Ibrahima Wade, General Coordinator of the Dakar 2026 Organising Committee (YOGOC). “Our motto, ‘Africa welcomes, Dakar celebrates’, reﬂects this collective responsibility: these are not simply Dakar’s Games, but a milestone for Africa as a whole.” This historic milestone will see around 2,700 athletes from all National Olympic  2  Committees competing across 14 days of competition, with events staged in Dakar as well as Diamniadio, a rapidly developing city approximately 30 kilometres east of the Senegalese capital, and Saly, a beach resort that lies 80 kilometres to the south. “This is really monumental,” says Humphrey Kayange, an IOC Member and the Chair of the IOC Coordination Commission for Dakar 2026. “Hosting the Games on behalf of the continent is huge. “For Africa, the potential that comes with hosting such an event is enormous. It will shape the future for the continent and for everyone coming to celebrate the Games on a new continent for the ﬁrst time. “But this is also about more than hosting the Games. It is a statement of belief that there is huge opportunity on the continent and that Africa can take a leading role in this space.”  Young at heart Major international sporting events have been held on the continent before, with the 1995 Rugby World Cup and the 2003 ICC Cricket World Cup being notable early milestones. Perhaps the biggest breakthrough, though, came with the 2010 FIFA World Cup, which demonstrated Africa’s ability to stage an event on a massive global scale. Regular events such as the African Games and the"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 19-quote\" style=\"top:532px;left:289px;\" src=\"/126/static/_content/19-quote-text-1.png\"/>\n      <img class=\"abs halfScaleC 19-quote-img\" style=\"top:487px;left:195px;\" src=\"/126/static/_content/19-quote-img-1.png\"/>\n    \n      ",
    "script": "\n        function onPageEnter() {\n          pg19Anim = new TimelineMax();\n          pg19Anim.fromTo(cOf(\"19-quote-img\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"19-quote\"), 0.9, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg19Anim.stop();\n        }\n      ",
    "searchText": "19  3  Africa Cup of Nations have also continued to build experience across the continent in organisation, infrastructure and delivery. Dakar 2026 builds on that foundation, while introducing a stronger focus on using sport to support long-term development. With around 75 per cent of Senegal’s population under the age of 35, Dakar 2026 is placing young people at the centre of this approach, launching numerous programmes in the lead-up to the Games that aim to improve access to sports and create opportunities for the country’s youth. “Young people are not only an audience for these Games – they are at the heart of their delivery,” explains Wade. Under the “Jeunesse en Jeux” vision, up to 300,000 young people are expected to experience the Games, not only as spectators but also as active participants in sporting, cultural and educational  “It will shape the future for the continent and for everyone coming to celebrate the Games on a new continent for the first time” HUMPHREY KAYANGE  activities. This builds on initiatives that have already engaged more than 480,000 young people across the country. One of the most ambitious programmes is the Brevet olympique, civique et sportif, an educational programme focused on the Olympic values that aims to reach up to 900,000 children in 11,000 schools by the time the Games start in October. Alongside this, the Kids’ Olympic Skills initiative is giving young people aged  6–18 the opportunity to try a range of sports, helping to build interest and participation at grassroots level. At the same time, Dakar 2026 is investing in skills development through its Learning Academy (see page 30), which will train hundreds of young Senegalese and African professionals in sports and event management. Many of these participants are expected to go on and play a role in delivering the Games, creating a direct link"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:212px;left:41px;width:88px;height:15px;\">  \n        <a href=\"https://www.olympics.com/ioc/news/six-months-to-go-to-dakar-2026-ioc-young-leaders-ready-to-turn-olympic-values-into-action\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "20  Dakar 2026 preview  between youth engagement and the organisation of the event itself. Other initiatives will also give young people experience beyond sport and event delivery. Fifteen aspiring sports journalists have been selected for the IOC Young Reporters Programme, including six from Africa and three from Senegal, while eight IOC Young Leaders will be in Dakar to deliver sport-based activities with young athletes and local communities. The volunteer programme, Jambaar26, has also generated strong interest, with  1  1  more than 14,000 applications received from 115 countries for more than 5,000 roles – underlining both local and international enthusiasm for the Games. “The Games are an invitation to every young Senegalese person, regardless of whether they ever set foot on a track or in a pool,” adds Wade. “Through the school programme, the volunteer experience and the Learning Academy, an entire generation is being given the opportunity to engage with these Games as participants rather than observers.”  New generations, new sports These initiatives and others together reﬂect Dakar 2026’s broader objective of using the YOG as a catalyst for youth development, with programmes that extend beyond sport to support education and social inclusion across Senegal and the wider region. One of the most visible expressions of this approach so far has been Dakar en Jeux, an annual festival launched in 2022 that has helped engage local communities, promote healthy lifestyles and grow momentum in the build-up to the Games. Organised across the Dakar 2026 host cities, the initiative has brought together sport and culture each year through a programme of activities that includes introductory sports sessions, demonstrations, concerts and artistic performances. Thousands of young people have already taken part, with events designed to encourage participation and promote physical activity, and workshops providing education on health and well-being. The festivals have also provided an opportunity to introduce new sports to local audiences. BMX, skateboarding, futsal and roller sports have featured alongside more traditional disciplines, giving young people the chance to try a range of sports, including those that will form part of the Dakar 2026 programme.  Joining the culture club Dakar en Jeux has placed a strong emphasis on cultural expression, with music, dance and street art playing a central role in each edition. The aim is to reﬂect the identity of Senegal while creating a connection between the Games and the communities that will host them. This celebration of culture will also be visible during the Games themselves, with Dakar 2026 placing a strong emphasis on the Senegalese concept of “Teranga” – a Wolof word that embodies the hospitality, generosity and sense of community that deﬁne daily life in the country. This spirit is set to shape the Games for both athletes and visitors, with organisers aiming to create an environment that reﬂects Senegal’s openness and warmth.  1 More than 14,000 applications have been received for the Jambaar26 volunteer programme."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 22-quote\" style=\"top:695px;left:291px;\" src=\"/126/static/_content/22-quote-text-1.png\"/>\n      <img class=\"abs halfScaleC 22-quote-img\" style=\"top:651px;left:195px;\" src=\"/126/static/_content/22-quote-img-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim.fromTo(cOf(\"22-quote-img\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"22-quote\"), 0.9, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg22Anim.stop();\n        }\n      ",
    "searchText": "22  Feature: Dakar 2026 Overview  1  1  “Teranga – the Senegalese tradition of hospitality and generosity – is not a communication concept,” says Wade. “It is a lived reality, and the Games have been designed so that every visitor feels it from the moment of arrival.” For the young athletes, this will be most visible in the Youth Olympic Village, where they will meet local craftspeople, discover traditional games and learn West African drumming and dance practices such as sabar and djembé. At competition venues, cultural performances will welcome every delegation, while the Yeesal project, meaning “renewal” in Wolof, is transforming the urban landscapes of Dakar, Diamniadio and Saly into an open-air gallery, with large-scale murals by local artists inspired by the Olympic values. One of the ﬁrst is the artwork depicting Faye, Seck and Gomis at Colobane train station.  Going local The emphasis on local identity and youth engagement is also reﬂected in how the Games themselves have been designed. For Dakar 2026, the IOC has introduced a new approach to the YOG sports programme, with a stronger focus on adapting each edition to its host country and region. Dakar 2026 will be the ﬁrst edition to beneﬁt from this model, with a tailored programme developed in close collaboration between the YOGOC and the International Federations (IFs).  The approach marks a shift away from a ﬁxed format, allowing each edition of the Games to reﬂect local priorities and opportunities while maintaining its role as an elite multisport competition. For Dakar 2026, this will see 25 sports included in the competition programme, alongside a further 10 sports that will form part of a new engagement programme. While the competition sports will follow a traditional format, the engagement programme is designed to give young people in the host communities the opportunity to discover and try new disciplines.  “An entire generation is being given the opportunity to engage with these Games as participants rather than observers” IBRAHIMA WADE  1 A music concert in Saly was one of many popular events at the Dakar en Jeux festival."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 23-title\" style=\"top:99px;left:43px;\" src=\"/126/static/_content/23-title-1.png\"/>\n\n      <h1 id=\"23-no\" class=\"abs olympicHeadlineComp 23-no\" style=\"top:181px;left:496px; font-size: 1.9em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 2700, \"comma\" : true}' ></h1>\n\n      <div class=\"addContentLink\" style=\"top:98px;left:219px;width:292px;height:44px;\">  \n        <a href=\"https://www.olympics.com/fr/dakar-2026/en/joj-dakar-2026-programme-et-calendrier-de-competition/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg23Anim = new TimelineMax();\n          pg23Anim.staggerFromTo(cOf(\"23-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1)\n          .fromTo(cOf(\"23-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"23-no\")[0])}}, 1.2);\n        }\n\n        function onPageLeave() {\n          pg23Anim.stop();\n          removeContentLinks();\n          resetNumbers(\"23-no\");\n        }\n      ",
    "searchText": "Olympic Review  23  Issue 126  DAKAR 2026 SPORTS PROGRAMME 25 COMPETiTiON SPORTS  WHO TAKES PART? 2,700  athletes (maximum age: 17)  Aquatics  Archery  Athletics  Badminton  Baseball/softball  Basketball  Boxing  Breaking  Cycling  Equestrian  Fencing  Football  Gymnastics  Handball  Judo  Rowing  Rugby  Sailing  Skateboarding  Table tennis  Taekwondo  10 ENGAGEMENT SPORTS  Triathlon  Volleyball  WHO TAKES PART?  Canoe  Golf  Hockey  Karate  Sport climbing  Surﬁng  Tennis  Weightlifting  Wrestling  Wushu  Young people, local communities, fans onsite  Modern pentathlon  Shooting"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "24  Dakar 2026 preview  to the local context ensures that the YOG remain relevant while maintaining their role as a pathway to elite sport.”  1  Under African skies The thinking behind the sports programme also extends beyond competition, with Dakar 2026 aiming to support the development of a broader sports ecosystem in Senegal and across Africa. “Sport is already very popular in Africa,” says Wade. “But what we can add with the Youth Olympic Games is how to build a sports industry. This is something important.” This includes investment in skills, training and infrastructure, as well as efforts to strengthen national sports systems and create new opportunities for young people beyond competition. Programmes such as the Dakar 2026 Learning Academy are designed to equip participants with practical experience in areas such as event management, operations and administration, helping to build a workforce that can support future sporting events. The approach also reﬂects a wider ambition to position Dakar as a regional hub for sport, with the capacity to host international competitions and support athlete development over the long term. Through partnerships with IFs and support from Olympic Solidarity, initiatives are being implemented to strengthen coaching, athlete pathways and organisational capacity across the continent.  1  “We know that some sports are not yet well known in Africa,” explains Wade. “So we wanted to give IFs the opportunity to bring those sports and showcase them in one place.” These engagement sports will be presented through demonstrations, activations and festival-style experiences, allowing local youth to take part directly rather than simply watch. The aim is to build interest and participation in sports that may not yet have a strong presence in Senegal or the wider region. “We really hope the legacy will be that young people discover them and that these sports continue to grow after the Games,” says Wade. Kayange adds: “This is central to the approach. Adapting the sports programme  2  1 Behind the scenes with the 'Olympians giving back' panel at the Athlete Town Hall. 2 Shea McAleese is passing on knowledge to young people through his Inside Hockey business."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  25  Issue 126  Coupled with the youth engagement programmes and major investments in sporting infrastructure, these efforts are designed to ensure that the impact of Dakar 2026 extends far beyond the Games themselves, creating lasting opportunities for young people in Senegal and across Africa. “The material legacy is tangible and lasting,” says Wade. “The Games leave behind a transformed sporting infrastructure: a fully rehabilitated Complexe Iba Mar Diop, a renovated Olympic swimming pool, a world-class equestrian centre and 11 community sports facilities built in partnership with local authorities across the country. “The intangible legacy may prove even more signiﬁcant. Research on the long-term impact of Olympic Games consistently points to a set of effects that outlast the infrastructure: a lasting elevation of sporting culture, a strengthened sense of national cohesion and a meaningful advance in gender equality, both in access to sport and in the visibility afforded to women as athletes, leaders and role models.” According to Wade, this deeper impact may be the hardest to measure. “It is the moment a young girl in Dakar watches a female athlete from her own continent stand on a podium, or a young boy from Médina in Dakar sees his neighbourhood transformed into a site of international excellence. That shift in aspiration is what the Olympic Movement, at its best, has always produced. And it is what Dakar 2026 is determined to leave behind.” Much of that impact is already being shaped through the programmes introduced in the lead-up to 2026, with initiatives focused on education, skills development and access to sport designed to create opportunities that extend beyond the event itself.  1 Wushu will appear on the YOG sports programme for the ﬁrst time at Dakar 2026. 2 The Abdoulaye Wade Stadium will stage events in the host city of Diamniadio. 3 A packed crowd enjoys a music concert at Dakar en Jeux. 4 There will be two 3×3 basketball competitions at the YOG.  “We will be planting those legacy seeds,” says Kayange. “Some of the impact will be seen immediately, but much of it will grow over time.”  3  Counting down Before that legacy can take shape, attention now turns to the Games themselves, with anticipation building across Senegal and star names from the worlds of sport and culture among those expressing their excitement as the countdown to Dakar 2026 reaches its closing stages.  4"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 26-quote\" style=\"top:541px;left:311px;\" src=\"/126/static/_content/26-quote-text-1.png\"/>\n      <img class=\"abs halfScaleC 26-quote-img\" style=\"top:498px;left:196px;\" src=\"/126/static/_content/26-quote-img-1.png\"/>\n\n      <div class=\"contentLink\" style=\"top:578px;left:203px;width:36px;height:14px;\">  \n        <a href=\"https://www.olympics.com/en/video/kalidou-koulibaly-interview-dakar-2026-youth-olympic-games-change-africa-forever\" target=\"_blank\"></a>\n      </div>\n      <div class=\"contentLink\" style=\"top:592px;left:43px;width:43px;height:14px;\">  \n        <a href=\"https://www.olympics.com/en/video/kalidou-koulibaly-interview-dakar-2026-youth-olympic-games-change-africa-forever\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"contentLink\" style=\"top:713px;left:98px;width:56px;height:14px;\">  \n        <a href=\"https://www.olympics.com/en/news/who-is-khaby-lame-new-dakar-2026-ambassador\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim.fromTo(cOf(\"26-quote-img\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"26-quote\"), 0.9, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "26  Dakar 2026 preview  1  1  For Senegal national football team captain and Dakar 2026 ambassador Kalidou Koulibaly, the YOG represents a moment of pride for the whole African continent. “This is something that has never happened before,” he says. “This is historic because major events have taken place all over the world, but never in Africa. Now it is our turn. This event will show the world the talent and energy that exist across Africa.” Social media star and fellow Dakar 2026 ambassador Khaby Lame, the most followed creator on TikTok with more than 160 million followers, has also highlighted the wider signiﬁcance of the Games. “Dakar 2026 will give our continent the opportunity to reveal the best of itself and to inspire youth in Africa and around the world,” Lame says. “This is a chance to demonstrate that beyond its resilience, Africa is also a force. I am proud to be  “Dakar 2026 will give our continent the opportunity... to inspire youth in Africa and around the world” KHABY LAME  Senegalese, proud to be African, and we will make this ﬁrst Olympic event in Africa a total success.” Back at Colobane train station, commuters will continue to pass beneath the mural of Julie Marie Gomis, Combé Seck and Tening Faye each day as Africa’s ﬁrst Olympic event approaches. Looking up, they will see the faces of two stars of Senegalese sport alongside  a young athlete whose story is only just beginning, but who already represents the generation across Africa set to be inspired by this historic moment. ■  1 Dakar 2026 ambassador Khaby Lame with the official mascot, Ayo."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "28  Dakar 2026 preview  DiAMNiADiO 2km  AD  4  4 5  7  5  6 6  E  B  7 mins  3  20km  4. EQUESTRIAN CENTRE  2 2  17 mins  Dakar TER Station  Equestrian (Jumping)  60 mins  5. DAKAR ARENA  A  1  7. DAKAR EXPO CENTRE  10 mins  1. COMPLEXE TOUR DE L'OEUF 90 mins  10 mins  Badminton  Fencing  Futsal  3. CORNiCHE WEST  Boxing Table Tennis  110 mins  6. ABDOULAYE WADE STADIUM  Swimming 106 mins 106 10 6m ins 3×3 Basketball  Breaking EXE 1. COMPLEXE PLEX OE PLEX OMPL COM COM TO TOUR UR DE DE LOEUF LL'OEUF OEUF UF  Cycling Road Engagement sports Weightlifting  Breaking re king king B reaki  Karate Shooting  Ska Skateboarding teboar oarrd din ding ing (S Stre eet) et) et teb ((Street) 75kate mins  Surﬁng  YOV  Futsal min 87 87 mins in  MAIN HOSPiTAL OFR DAKAR OMPL 2. A. COMPLEXE CCOM OM PLEX EXE EX IBA MAR DIOP DIOP IBA MA PL 125 mins Rug gby Sevens ev Ru Rugby S evens ens Sev  B. MiLiTARY HOSPiTAL OF OUAKAM  Hockey Golf Modern Pentathlon  14 mins  Futsal  7 mins  Rugby Sevens  Canoe  ENGAGE SPORTS* ENGA ENGAGEMENT GAGEME GEMENT NT N SPORTS* S*  Locations o be e conﬁrmed conﬁrmed *Locations ations to *Lo  Taekwondo  G. CICAD  Triathlon (running)  Main Press Centre  10 mins  Weightlifting We ghtlif Weig liftin ing  Spo Sport port port Climbing Clilimb bing ng  Closing Ceremony  Te Tennis nnis  Hockey Ho Hoc cke key  19 mins D. THE GROUND 14 mins AR ARENA AREN A NA 5. DAKAR  At Athl etic ics Athletics ic et 125 mins  Ka Kar Karate ate te  Golf Golf  Shooti Sho Shooting g  Pe Modern Mod Mod rn Penta Pentathlon ntathl t o  125sal mins Futsal Fu Futsal  Surﬁ Surﬁng ﬁ g  Canoe Canoe  Main Operations Centre Technology Operations Centre  E. MAiN LOGiSTiCS HUB  26 mins  Athletics (track)  CCEN RE EQUESTRE 4 CENTRE 4. EQUESTRE EQUEST STRE 3×3 Basketball F. UNiFORM AND Equestrian Eq estrian strrian (Ju Equest mp ng) Equ ue p ng) ((Jumping) Baseball5 ACCREDiTATiON CENTRE  B Boxing xing xing  C. DAKAR 2026 HEADQUARTERS  6. STADE STA STADE DE ABDOULAYE ABDOU OULAYE LAYE YE W  Archer chery Archery A Intl’ Broadcast Centre Cyc ycling g Road Roa R d Cycling  Opening Ceremony  Sport Climbing  Taekwondo  Artistic Gymnastics ns 5 mi 5 mins mins Judo  Archery  Tennis  seb Baseball5 Bas eballll5 IBA MAR DIOP Ba 2. COMPLEXE  Athletics  Wushu (Taolu)  5 mins  Baseball5 Swimming mmi ming Swimmi Sw Skateboarding (Street) ×3 Ba 3 Bas ba 3×3 Basketball Basket ball ttba  Rugby Sevens  H  F  1 1 35km  Diamniadio TER Station  A1  DAKAR  C  7 G  Swimming Boxing  H. YOG HOSPITAL ns 19 mins 19 mins  Gymnastics Gymnas Gym nas s nastics  Ba Bad Badminton dminto to ton Artistic Gymnastics Triathlon (swimming)  mins 19 mins 19 ns  DAK EXPO 7. DAKAR EEXP XPO XPO CENTR CE Fencing Fe Fenc ing Taekkwo Ta won ndo do Taekwondo Table nn ble Te nis Tennis Taolu) Wushu Wu Wushu hu (Ta (T (Taolu) Taol Art Artistic ist st stic ic Gymnastics Gyym mnastic tic cs Jud Judo Judo o"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  29  Issue 126  BEYOND THE RINGS  DAKAR 2026 MASTER PLAN X X X  C Competition Venues  X X X  NON-Comp Venues N Competition  A1 H ig  Airport TER Station  Engagement Sports  Blaise Diagne International Airport  Youth Olympic Village  35 mins  35 mins  Blaise Diagne International Airport  igh y wa  RE  h wa y  Training  H A1  WADE WADE WAD  A1  A1 Highway Train Express Régional (TER) TER Stations Shuttle  20km  Travel time from YOV  35km  A1  THE VENUES  ATLANTIC OCEAN  56 m 56 mins in  8. SALY BEACH WEST PLAGEE OUEST 88. SALY PLAGE OUES UEST 55 mins  8 8  SALY  ((Windsurﬁng) Winds Sailing Sa dsurﬁ urﬁ rﬁng) ng) g) g (Win  Rowing Coastal Beach h R stal Be Bea Sailing (Windsurﬁng) Sprint Sprints Sp s ints Rowing Coastal Beach ch Volleyball Vollleyba eyballl Beach Sprints Beach Volleyball Beach ch n h Handball ll Beach Handball Wre stling Beach ch Wr Wrestling stl ing ng est Beach Wrestling Tri Triath athlon on Tr Triathlon Triathlon  50km  The Dakar 2026 YOG will be held across three host cities (Dakar, Diamniadio and Saly), with competitions taking place at eight venues in total – from the picturesque Saly Beach, home to six sports including beach handball and coastal rowing, to Corniche West, which will provide a stunning backdrop for the road cycling events. A central hub for festivities and youth engagement, Corniche West will also host the 10 engagement sports in the vibrant Espace Let’s Move zone."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 30-title\" style=\"top:104px;left:42px;\" src=\"/126/static/_content/30-title-1.png\"/>\n      <img class=\"abs halfScale 30-title\" style=\"top:250px;left:44px;\" src=\"/126/static/_content/30-title-2.png\"/>\n      <img class=\"abs halfScale 30-title\" style=\"top:400px;left:46px;\" src=\"/126/static/_content/30-title-3.png\"/>\n      <img class=\"abs halfScale 30-sub\" style=\"top:558px;left:43px;\" src=\"/126/static/_content/30-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax();\n          pg30Anim.staggerFromTo(cOf(\"30-title\"), 0.9, {opacity:0, x:35}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.2, 1)\n          .fromTo(cOf(\"30-sub\"), 0.9, {opacity:0, y:45}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.4);\n        }\n\n        function onPageLeave() {\n          pg30Anim.stop();\n        }\n      ",
    "searchText": "A LEGACY FOR THE GENERATiONS A PIONEERING TRAINING AND RECRUITMENT PROGRAMME FOR YOUNG GRADUATES, THE DAKAR 2026 LEARNING ACADEMY AIMS TO EQUIP MORE THAN 400 PEOPLE WITH THE PROFESSIONAL AND INTERPERSONAL SKILLS REQUIRED FOR ORGANISING INTERNATIONAL SPORTING EVENTS. THE SUCCESS OF THIS INITIATIVE HAS GONE BEYOND EXPECTATIONS AND BEYOND SENEGALíS BORDERS AND LIES AT THE HEART OF THE LEGACY OF THE DAKAR 2026 YOUTH OLYMPIC GAMES. BY LAURIANE NEMBROT  Sokhna Dia is one of the young graduates enrolled in the Learning Academy."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:289px;left:260px;width:116px;height:14px;\">  \n        <a href=\"https://www.olympics.com/ioc/news/dakar-2026-learning-academy-officially-launches-with-first-cohort-of-young-professionals\" target=\"_blank\"></a>\n      </div>\n      <div class=\"contentLink\" style=\"top:302px;left:260px;width:141px;height:14px;\">  \n        <a href=\"https://www.olympics.com/ioc/news/dakar-2026-learning-academy-officially-launches-with-first-cohort-of-young-professionals\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "32  Dakar 2026 Learning Academy  B  uenos Aires, 8 October 2018. The 133rd Session of the International Olympic Committee (IOC) took place in Argentina during the third edition of the Summer Youth Olympic Games (YOG), which followed the inaugural edition held in Singapore in 2010 and the Nanjing edition four years later. Following discussions at the Session and a vote of approval, Dakar was announced as the next host city for the YOG. The event was originally scheduled to take place four years later, in 2022. But the global COVID-19 pandemic scuppered this plan. Despite a four-year postponement, the decision remains historic. It is now 2026 and Senegal is preparing to host the very ﬁrst Olympic sporting event organised in Africa, from 31 October to 13 November. After the initial excitement, came the questions. The international French-speaking press in particular wondered whether the continent had sufficient human and operational resources to organise such an event.  1  The members of the Dakar 2026 Youth Olympic Games Organising Committee (YOGOC), officially established in February 2020, tackled the issue immediately. They decided that to successfully organise the ﬁrst Olympic sporting event on African soil, the YOGOC would need to recruit and then train most of its operational workforce in Senegal and across the continent. With the ambition of nurturing African talent in sports events, this vision aligned with the inclusive ethos of the Games’ motto, “Africa welcomes, Dakar celebrates”.  2  1  Dakar 2026 Learning Academy: the beginnings Dakar, May 2026. In her office at the YOGOC, Fatimata Diaw, Head of Protocol, recalls the early days of the Dakar 2026 Learning Academy. The project came to life as a result of joint discussions held in Paris during the summer of 2024, during which the IOC presented the concept to the YOGOC. When she joined the Organising Committee in  1 A group of Learners from the ﬁrst cohort of the Learning Academy. 2 The Dakar 2026 Learning Academy aims to equip participants with professional and life skills. 3 Learners will actively contribute to the development of the upcoming YOG."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  33  Issue 126  November 2024, Diaw was tasked with launching this project. “Apart from a PowerPoint slide, there was nothing – no information. We had to start from scratch,” she says. “At ﬁrst, no one quite believed in it.” In order to support the YOGOC in the implementation of its educational initiative, a joint IOC-Dakar 2026 steering committee was set up to develop a multimodule training programme tailored to speciﬁc local needs. Under the leadership of Bocar Laurent Sy, Dakar 2026 Executive Director and Head of Human Resources, and in close collaboration with the IOC, a small team was built around Diaw and Felix Gaye, who is in charge of the YOGOC’s workforce. Everyone worked tirelessly to set up the programme. “We had to hold endless meetings, seek out partners and draw up a staffing plan. We had to act fast as we needed to launch the ﬁrst cohort of the Learning Academy in early 2025,” Diaw emphasises. But very quickly, other obstacles surfaced. The young team, highly motivated and determined to see the project through, encountered considerable resistance. “For most people within the YOGOC, it was very difficult, if not impossible, to imagine that we would deliver the Games with people who had never done this before,” recalls Diaw. Sitting beside her, Gaye sums up the scale of the task but also highlights the value of such an undertaking. “These are roles that most of the people we were going to recruit had never held before,” he explains. “We couldn’t necessarily count on any existing experience on the ground. And when you’re building an Organising Committee, the strategy can’t be to say: ‘We’re going to recruit 100 per cent of people from other Organising Committees.’ It simply doesn’t work like that. “And then, for the ﬁrst YOG in Africa, it was also important that it should be Africans who organise and deliver them.” Despite the challenges, they ignored the naysayers and focused on the project’s end goal: launching the Dakar 2026 Learning Academy, now dubbed “LA” internally. This intensive training programme, delivered in collaboration with the IOC, and aimed at young graduates aged 21 to 35 who wanted to be part of the organisation  3  of Dakar 2026, is unprecedented. Indeed, in the history of the Olympic Games and the IOC, no other Organising Committee has ever set up such a scheme. The YOGOC and the IOC, keen to stay as true as possible to the concept of continent-wide inclusion, invited every African National Olympic Committee to nominate a candidate to join the venture and beneﬁt from the Learning Academy experience. This initiative is enthusiastically supported by Olympic Solidarity. This concept will later be extended to Olympians, who will be offered an opportunity for professional reorientation once they retire from their careers as elite sportspeople.  Unlocking African potential In the many years he spent travelling the world as a human resources manager for different multinational organisations, Sy had the opportunity to observe ﬁrsthand the recruitment model applied in Nordic countries. He drew inspiration from this  to develop the recruitment process for the students of the Academy. “It was a very long, often difficult process; we didn’t always see eye to eye and there were moments of tension,” Sy recalls. “But I never doubted the feasibility of this project. The initial format has evolved signiﬁcantly. But on the eve of the launch of the ﬁrst cohort in April 2025, when we saw all the Learners gathered together, we realised we’d made the right choice.” This expertise, made available to the Learning Academy, has notably enabled people from different backgrounds to join the YOGOC and to play an active role in organising the Games. People, for example, like 25-year-old Sokhna Dia. Dia was unable to ﬁnd work in her chosen ﬁeld after ﬁnishing her university studies, so she joined a cleaning company – and her ﬁrst assignment was the YOGOC offices. While working ﬂat out, Dia observed the preparations from a distance. Fascinated by everything she saw, she decided to"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n      \n      <h1 id=\"34-no\" class=\"abs olympicHeadlineComp 34-no\" style=\"top:492px;left:81px; font-size: 6.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 11928, \"comma\": true}' ></h1>\n\n      <h1 id=\"34-no\" class=\"abs olympicHeadlineComp 34-no\" style=\"top:492px;left:313px; font-size: 6.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 263}' ></h1>\n\n      <h1 id=\"34-no\" class=\"abs olympicHeadlineComp 34-no\" style=\"top:600px;left:276px; font-size: 4.6em; font-weight: 300; color: #a0d5b3; padding: 0px; margin: 0px;\" data-number='{\"to\": 29}' ></h1>\n\n      <h1 id=\"34-no\" class=\"abs olympicHeadlineComp 34-no\" style=\"top:600px;left:390px; font-size: 4.6em; font-weight: 300; color: #a0d5b3; padding: 0px; margin: 0px;\" data-number='{\"to\": 27}' ></h1>\n\n      <h1 id=\"34-no\" class=\"abs olympicSansBd 34-no\" style=\"top:762px;left:316px; font-size: 0.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 49.4, \"append\" : \"%\", \"decimals\" : 1 }' ></h1>\n\n      <h1 id=\"34-no\" class=\"abs olympicSansBd 34-no\" style=\"top:762px;left:361px; font-size: 0.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 50.6, \"append\" : \"%\", \"decimals\" : 1 }' ></h1>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim.fromTo(cOf(\"34-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[0])}}, 1.0)\n          .fromTo(cOf(\"34-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[1])}}, 1.0)\n          .fromTo(cOf(\"34-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[2])}}, 1.1)\n          .fromTo(cOf(\"34-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[3])}}, 1.1)\n          .fromTo(cOf(\"34-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[4])}}, 1.2)\n          .fromTo(cOf(\"34-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[5])}}, 1.2);\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop();\n          resetNumbers(\"34-no\");\n        }\n      ",
    "searchText": "34  Dakar 2026 Learning Academy  1  1  LEARNiNG ACADEMY IN NUMBERS  11,928  Total number of applicants:  263  Learners enrolled:  29  Nationalities  27  Median age Gender ratio  49.4% male  50.6% female  follow the YOGOC on social media. That’s how she came across the call for applications for the ﬁrst cohort of the Learning Academy. “As part of the application, we had to make a video presentation,” she says. “I decided to ﬁlm mine in the YOGOC offices one morning while I was cleaning.” Her approach impressed the Learning Academy’s recruiters, who quickly recognised Dia’s boundless motivation. Dia now works for Dakar 2026 as the Youth Olympic Village Coordinator. Pape Moussa Sarr, the Learning Academy Recruitment Officer, explains: “Sokhna Dia’s journey perfectly illustrates the transformative power and potential of this programme.” Her progress “shows that with the right training and quality support, young people from Senegal and across Africa are capable of achieving remarkable things, just like other young people around the world, if not more so”.  An impact beyond Africa The enthusiasm for the Dakar 2026 Learning Academy has surpassed all expectations. Thousands of applications have been received and the number is rising signiﬁcantly with each new round of recruitment. At Olympic House in Lausanne, the Learning Academy is also engaging members of the IOC administration, who volunteer as instructors during the training weeks. The ﬁrst two weeks focus on understanding the Olympic Movement, competitive sports, stakeholders, the functioning of the various departments within the Organising Committee and the importance of collaborative work, with visits to competition venues designed to familiarise participants with on-site operations. The third week focuses on personal development, including stress management and public speaking. All these tools are compiled and made available in a Learning Journal – considered to be the Learners’ bible. “Some, perhaps most, already have the skills,” says François-Marie Bourgeois, Senior Project Manager in the IOC’s Sports Department, who has visited Senegal several times since the start of the Learning Academy and has led training workshops  1 Over 260 Learners have enrolled for the Dakar 2026 Learning Academy."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Open always wins Victory is a team sport  Image simulated. UX/UI may differ."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 36-quote\" style=\"top:694px;left:95px;\" src=\"/126/static/_content/36-quote-text-1.png\"/>\n      <img class=\"abs halfScaleC 36-quote-img\" style=\"top:649px;left:-22px;\" src=\"/126/static/_content/36-quote-img-1.png\"/>\n    \n      ",
    "script": "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax();\n          pg36Anim.fromTo(cOf(\"36-quote-img\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"36-quote\"), 0.9, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg36Anim.stop();\n        }\n      ",
    "searchText": "36  Dakar 2026 Learning Academy  1  for each cohort. “This programme enables them to acquire knowledge. After their training and once they join their departments, we have noticed that the Learners are more operational. They know what we’re talking about, they learn faster and they have a broad overview of the subject. It’s an accelerator.” Aurélie Lemouzy, Senior Legacy Manager in the IOC’s Olympic Games Department and also a Learning Academy instructor, adds: “Of all the training courses I’ve run, I have never seen such a high level of positivity in a group. The level of individual and collective motivation is unparalleled.”  A legacy for the future The professional and interpersonal skills acquired by the students of the Academy, coupled with the experience of helping to organise the ﬁrst Olympic sporting event to be held in Africa, are already part of the legacy of the Dakar 2026 YOG. Ibrahima Wade, General Coordinator of Dakar 2026, says he is “convinced” that the Learners “will be able to make the most of the opportunities offered by this truly exceptional experience”. For him, the Dakar 2026 Learning Academy is “undeniably a demanding programme, but one of incomparable value”.  Wade, who is also a senior official in the Senegalese civil service, adds: “The skills they will have acquired, both during the event and throughout the planning and preparation phases, will be invaluable and transferable to any activity sector.” While Senegal is already beneﬁting from the operational resources channelled through this programme, the future of the “LA” looks promising. Following the ﬁrst African YOG, this training model could be replicated at future editions of the Olympic Games. History may well record that the host city of the next Olympic Games shares the same initials as the ﬂagship training project of Dakar 2026. A sign of destiny? ■  “The skills [the Learners] will have acquired… will be invaluable and transferable to any activity sector” IBRAHIMA WADE 1 The Diamniadio Olympic Stadium hosts Learning Academy participants."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 38-title\" style=\"top:386px;left:42px;\" src=\"/126/static/_content/38-title-1.png\"/>\n      <img class=\"abs halfScale 38-title\" style=\"top:542px;left:44px;\" src=\"/126/static/_content/38-title-2.png\"/>\n      <img class=\"abs halfScale 38-sub\" style=\"top:700px;left:44px;\" src=\"/126/static/_content/38-sub-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax();\n          pg38Anim.staggerFromTo(cOf(\"38-title\"), 0.9, {opacity:0, x:35}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.2, 1)\n          .fromTo(cOf(\"38-sub\"), 0.9, {opacity:0, y:45}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.4);\n        }\n\n        function onPageLeave() {\n          pg38Anim.stop();\n        }\n      ",
    "searchText": "A CULTURAL SHOWCASE THE FIRST OLYMPIC SPORTING EVENT TO BE HELD ON THE AFRICAN CONTINENT, THE DAKAR 2026 YOUTH OLYMPIC GAMES ARE ALSO AN OPPORTUNITY TO HIGHLIGHT A WEALTH OF EXPERTISE AND A CULTURAL AND HISTORICAL HERITAGE STILL LARGELY UNKNOWN TO THE WORLD. BY CÉLIA CUORDIFEDE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "The Dakar 2026 YOG will be a celebration of culture, music and street art."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "40  Feature: Dakar 2026 Overview  1  I  n the streets of Dakar, Senegal’s bustling capital, the history of the Youth Olympic Games (YOG) is being written. Everywhere, it is spreading softly, like the whisper of a griot at the start of a folk tale. This is the ﬁrst time the YOG will be held in Africa. Day by day, this legend made up of sporting feats, discoveries and the promotion of local cultures is winning over the hearts and minds of the city, the nation and even the continent. It is becoming a reality, often through word of mouth, and sometimes through symbolic displays or high-proﬁle events. In these moments, there is a mood of growing excitement and anticipation. Taking place from 31 October to 13 November 2026 across the cities of Dakar, Saly and Diamniadio, the event is fuelling more curiosity and creative enthusiasm with each passing day. While today, “Africa welcomes, Dakar celebrates” (“Afrig Dalal, Ndakaaru Jëmël” in Wolof), to quote the official motto of Dakar 2026, Dakar has long been a source of inspiration, innovation and  fascination. Those who have set foot on the peninsula know this already. But the YOG are an opportunity to demonstrate this to the rest of the world. So alongside the sporting action, culture is also part of the YOG. “The Dakar 2026 Youth Olympic Games are not merely an African ﬁrst in sporting terms – they are a historic ﬁrst in the fullest sense, almost a civilisational one,” says Mamadou Diagna Ndiaye, President of both the Senegalese National Olympic and Sports Committee (SNOSC) and the Dakar 2026 Organising Committee. “Culture is essential here because it is through culture that a nation and a continent present their faces to the world. It gives meaning to the event – it lends it a depth that sport alone could never achieve,” he says.  1 The African Renaissance Monument is a striking landmark on the Dakar hills. 2 The eye-catching mural at the TER station in the Colobane district, co-created by the artist Zeinixx.  Across the generations On a cool May night in Dakar, as gusts of Saharan dust blow onto faded walls, Souleymane Diop makes the trip to the brand-new Train Express Régional (TER) station in the Colobane district. There is a rumour doing the rounds in the city about a work of art on display right in the heart of Dakar. “It’s deﬁnitely there,” conﬁrms Diop, a shopkeeper who owns a stall at the nearby Soumbédioune craft market – ﬂashing a selﬁe. Before him stands a huge, brightly coloured mural measuring nearly seven metres by four. Bearing the YOG logo, “Dakar 2026 Youth Olympic Games”, it features portraits of three female Senegalese athletes. “It’s really beautiful,” comments Diop, along with other curious onlookers. At the base of the sky-blue wall, the ﬁrst face to emerge is that of the iconic smiling Julie Marie Gomis, the country’s ﬁrst female Olympian in 1976, who competed in the women’s 100m hurdles. Next comes the determined expression of the canoeist"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 41-quote\" style=\"top:203px;left:387px;\" src=\"/126/static/_content/41-quote-text-1.png\"/>\n      <img class=\"abs halfScaleC 41-quote-img\" style=\"top:37px;left:412px;\" src=\"/126/static/_content/41-quote-img-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg41Anim = new TimelineMax();\n          pg41Anim.fromTo(cOf(\"41-quote-img\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"41-quote\"), 0.9, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg41Anim.stop();\n        }\n      ",
    "searchText": "Olympic Review  41  Issue 126  2  “Culture is essential here because it is through culture that a nation and a continent present their faces to the world” MAMADOU DIAGNA NDIAYE  Combé Seck, 30. An African canoe sprint champion in 2025, she was one of Senegal’s two ﬂag-bearers at the Paris 2024 Olympic Games. And last, at the top, is the youthful, hope-ﬁlled face of 15-year-old Tening Faye, bronze medallist in her category at the 2025 World Taekwondo Cadet Championships in Fujairah, United Arab Emirates, completing this panorama of three generations of Senegalese athletes. “It’s brilliant! I didn’t know all this was happening – a friend told me about it and I wanted to see for myself,” explains Diop. “It’s a good idea to create a buzz leading up to the event. It makes people want to ﬁnd out more, to go further.” The artwork appeared on the wall of the capital’s busiest TER station in March. It certainly attracts attention in the hectic streets of Dakar, where the bright yellow and blue of express coaches and old taxis are already a ubiquitous sight. “The vibrant colours and the eye-catching background patterns immediately convey that this welcome is special to Senegal and more widely to the Sahel and Africa,” explains Dieynaba Sidibe, alias Zeinixx, a graffiti artist and co-creator of the mural. The 35-year-old artist, the ﬁrst ever female Senegalese graffiti artist, has once again broken new ground. She spearheaded the initiative to give a voice to the capital’s walls as part of the project known as Yeesal"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:266px;left:187px;width:36px;height:14px;\">  \n        <a href=\"https://www.olympics.com/en/news/senegalese-artist-serigne-mansour-fall-painting-purpose-art-responsibility\" target=\"_blank\"></a>\n      </div>\n      <div class=\"contentLink\" style=\"top:280px;left:44px;width:57px;height:14px;\">  \n        <a href=\"https://www.olympics.com/en/news/senegalese-artist-serigne-mansour-fall-painting-purpose-art-responsibility\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"contentLink\" style=\"top:528px;left:405px;width:32px;height:14px;\">  \n        <a href=\"https://www.olympics.com/en/news/dakar-2026-youth-olympics-ndeye-mariama-diop-young-designer-mascot-ayo\" target=\"_blank\"></a>\n      </div>\n      <div class=\"contentLink\" style=\"top:540px;left:259px;width:62px;height:14px;\">  \n        <a href=\"https://www.olympics.com/en/news/dakar-2026-youth-olympics-ndeye-mariama-diop-young-designer-mascot-ayo\" target=\"_blank\"></a>\n      </div>\n    \n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "42  Cultural showcase  in Wolof, which aims to place urban art at 1 the heart of the YOG. For the occasion, Dakar and its working-class suburbs, including Ruﬁsque and Bargny, as well as Diamniadio and Saly, is becoming an open-air gallery. In total, 43 murals measuring seven metres by four metres and designed by 43 graffiti artists will be painted in the coming weeks – mainly at train stations. “The Yeesal project is a way of giving many young people the opportunity to express themselves and bring their artistic contributions to the YOG,” states Serigne Mansour Fall, better known as Mad Zoo, Artistic Director of the Yeesal project and himself a graffiti artist. “These aren’t just decorative murals – we’re talking about engaging murals that put the continent’s sporting successes into perspective.”  “A true symbol of our culture” The 43 graffiti artists, selected over the past few months through a call for proposals, have already submitted designs on the themes of sporting legacy, the Olympic values – excellence, respect and friendship – 1 cultural diversity. Like Zeinixx’s, which and depicts three generations of Senegalese sportswomen, most of the murals will highlight athletes’ sometimes forgotten or overlooked successes. “Beyond sport, the idea is also to promote street art, to give young artists the chance to take part in the YOG and showcase their talent, and potentially to launch careers,” says Fall. In a country like Senegal, where graffiti is not strictly forbidden but rather “tolerated”, the official involvement in such a street art project feels like “a continuation of an art form that has always served society”, believes Zeinixx. In this West African country, graffiti emerged from the “Set Setal” movement in the early 1990s, when thousands of young people commandeered the walls of their neighbourhoods to publicise major clean-up operations – painting murals to inform the public about hygiene and public health issues. “The fact that graffiti is now being called upon for the YOG is a true symbol of our culture, a recognition and, above all, a source  1 Ayo, the lion cub mascot for Dakar 2026, has spread the message of the YOG across Senegal. 2 In total, 43 murals are being created by graffiti artists for the Yeesal project.  of immense pride,” says Zeinixx with delight. All the more so because, thanks to these YOG-themed murals that will spring up across Senegalese neighbourhoods, graffiti’s primary purpose – education through art – is being brought back into the spotlight. “The more murals we create, the more people will have access to information about the YOG event, the history of sport and about our heroes, and the greater the enthusiasm will be,” believes Mad Zoo. “It was essential for the organisers to grasp the importance of our cultural expression – of which graffiti is a part – to spark public interest and ensure that we make these Games something by us and for us, and not just when it comes to sport.”  “A positive light” Inspired by the Yeesal project, numerous initiatives bringing together art and sport have been launched across the whole of Senegal over the past two years, most often through calls for proposals or competitions. One of the most emblematic was the competition to design the Dakar 2026 mascot. Organised in late 2025, the event was run directly by Senegal’s Ministry of Education and involved 500 pupils from 41 schools across 16 regions throughout the country. After three selection rounds, the chosen winner was the design by Ndeye Mariama Diop, a 16-year-old schoolgirl from  1  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 43-quote\" style=\"top:552px;left:78px;\" src=\"/126/static/_content/43-quote-text-1.png\"/>\n      <img class=\"abs halfScaleC 43-quote-img\" style=\"top:506px;left:-22px;\" src=\"/126/static/_content/43-quote-img-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg43Anim = new TimelineMax();\n          pg43Anim.fromTo(cOf(\"43-quote-img\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"43-quote\"), 0.9, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg43Anim.stop();\n        }\n      ",
    "searchText": "Olympic Review  43  Issue 126  “The fact that graffiti is now being called upon for the YOG is a true symbol of our culture... a source of immense pride” ZEINIXX  Saint-Louis – the capital of the Saint-Louis region, on the border with Mauritania. Passionate about drawing since childhood, particularly manga, the schoolgirl took inspiration from her daily life to root the character “both in Senegalese traditions and in modernity”, she tells Olympic Review. The lion cub named Ayo (“joy” in Yoruba – a language widely spoken in West Africa) has a smiling face.  “I told myself that the character should be funny rather than serious, so that children would love him and he’d bring joy wherever he went,” explains Diop. Ayo also wears a tengaade (the traditional conical ﬁbre hat of the Fulani, a community with a strong presence in West Africa) and a football shirt, the sport being very popular with young people.  “I wanted to blend traditional and contemporary clothing and, above all, with a view to inclusion, to give a nod to the talibés [street children traditionally entrusted by their families to Quranic schools for their religious education], who are usually dressed in cheap shirts found on market stalls across the country,” she explains with disconcerting maturity. “I came up with the idea for this mascot as an opportunity to have a ﬁctional character to represent Senegal across the world in a positive light.” A symbol of unity ahead of the start of the YOG, the mascot was even presented to Bassirou Diomaye Faye, the President of the Republic. “The Dakar 2026 YOG will be a moment of glory for Senegal and for Africa… With six months to go before the opening of the Games, our country is counting on the"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:325px;left:566px;width:84px;height:14px;\">  \n        <a href=\"https://www.olympics.com/en/news/dakar-2026-volunteer-uniforms-victory-ceremonies\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "44  1  A CEREMONiAL FEEL Designed by Senegalese fashion house Algueye Dakar, the volunteer uniforms for the victory ceremonies at Dakar 2026 are based on a deliberately minimalist approach, which will allow the athletes to take centre stage. Showcasing the creativity and craftsmanship of Senegalese artisans, the modern design celebrates the cultural richness of the host country. The silhouette features a tulip collar and woven pagne, which is a powerful symbol of West African dress and fashion. 1  2  involvement of the arts and culture sector to rise to this national challenge and continentwide endeavour,” declared the head of state last April.  “A force on the international stage” From an economic, social and cultural perspective, the YOG represent a historic milestone for this country with a population of around 18 million. “The YOG, like all international events, are a showcase for expertise and for institutional and private stakeholders, providing an opportunity to show the entire world what Senegal is all about in every respect,” underlines Jean-Baptiste Guégan, a specialist in the geopolitics of sport and a lecturer on the history and geopolitics of African sport at Sciences Po in Paris."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  45  Issue 126  “In this approach, there is an element of public diplomacy, and cultural diplomacy in particular, which some might be tempted to reduce to ‘soft power’, but it goes far beyond that. Through this event, Dakar is positioning itself as a force on the continental, regional and international stage.” Building on the narrative of these YOG with initiatives throughout Senegal’s young society, the lion cub Ayo, who has come to life as a giant cuddly toy, is touring the country. As a vehicle for information about the historic event, Ayo is spreading the message of the Games, much like the graffiti artists of the Yeesal project. And the choice of locations highlights Senegal’s historical and cultural heritage. In early March, the icon set foot on the island of Gorée, a global symbol of the transatlantic slave trade. After a brief visit to the pupils of the prestigious Mariama Bâ girls’ school, named after the renowned Senegalese writer, the lion cub set off to explore the House of Slaves and the Gate of No Return, from where slaves were shipped off to the colonies. The site, steeped in emotion and history, will be a must-see for visitors during the YOG. Ayo has led the way. In the same vein as the mascot design competition, the anthem that will ring out in the arenas that usually stage wrestling (the hugely popular national sport), and some of which have been converted to host other events, on the beaches bordering the Atlantic and in the brand-new stadiums, is due to be unveiled at the end of June. The music that will provide the soundtrack for the two weeks of competition will be selected from a shortlist of 50 entries. Entitled “Wonéel sa bop” in Wolof (“Reveal Yourself”), the project has mobilised a large part of the country’s music industry – from performers to instrumentalists, and from beatmakers to producers and composers. The contest is an opportunity to demonstrate to the world the strength of Senegal’s music culture, born of griot songs and now widely popularised by mbalax, whose “king” Youssou N’Dour will be a key member of the jury. 1 The volunteer uniforms for the victory ceremonies celebrate the cultural richness of Senegal. 2 Artists perform a traditional dance at Obama Beach in Saly. 3 Samba Peuzzi takes the stage at the opening concert of Dakar en Jeux in 2023.  3  3"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:239px;left:208px;width:28px;height:14px;\">  \n        <a href=\"https://www.olympics.com/ioc/dakar-2026-culture\" target=\"_blank\"></a>\n      </div>\n      <div class=\"contentLink\" style=\"top:252px;left:42px;width:38px;height:14px;\">  \n        <a href=\"https://www.olympics.com/ioc/dakar-2026-culture\" target=\"_blank\"></a>\n      </div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Olympic Review  47  Issue 126  For the medal production and the design of the Senegalese athletes’ outﬁts, calls for proposals from young designers and artisans from across the country have, once again, been prioritised. “There’s a lot going on – it’s a very stimulating environment for creativity,” says Mouhamadou El Amine Diallo, founder of the fashion brand Kamal Raw. The designer was a participant in a catwalk show last November during the fourth edition of Dakar en Jeux, an annual cultural and sporting festival launched in 2022 with the aim of enhancing the technical aspects of the YOG’s organisation and boosting public enthusiasm and excitement.  “Africa is on the move” While the Dakar 2026 YOG are intended to provide a platform for the athletes of tomorrow, the SNOSC is keen to make sure that the event has the same impact on the rest of the country’s young people. “In all previous editions, beyond sport, the cultural dimension has been one of the most important aspects,” states Fanta Diallo, Director of Engagement and Mobilisation at the Dakar 2026 Organising Committee. “We were keen to follow this principle, and since we are talking about the Youth Olympic Games, it was even more important to open up opportunities for young people to display their creativity and ensure that they too can play their part.” Committed to ensuring that these Games serve as a social and educational catalyst, the SNOSC has also launched a certiﬁcation scheme to enable a wide range of organisations, institutions, private-sector players and other associations to be involved in the YOG programme across Senegal – and demand is growing. “On condition that they convey the Olympic values, namely excellence, respect and friendship, but also offer opportunities, particularly learning opportunities, to young people,” explains Diallo. During the two weeks of celebrations, an array of festivals, concerts, street performances, catwalk shows and other public events are planned near the competition venues and in the host cities of Dakar, Diamniadio and Saly.  2  Beyond sport, the YOG are also an opportunity to demonstrate Senegal’s ability to host a major international event, supported by an entire continent. This is an uplifting narrative at a time when Africa is rarely viewed in a positive light. “Through these Games,” says Mamadou Diagna Ndiaye, “we want to show an Africa that is on the move, inventive and bold – an Africa that is not content merely to inherit, but one that creates, innovates and inﬂuences.” ■  1 A model takes part in a fashion show during the Dakar en Jeux festival. 2 Percussionists put on a show at Obama Beach in Saly."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 48-title\" style=\"top:609px;left:21px;\" src=\"/126/static/_content/48-title-1.png\"/>\n      <img class=\"abs halfScale 48-title\" style=\"top:736px;left:165px;\" src=\"/126/static/_content/48-title-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax();\n          pg48Anim.staggerFromTo(cOf(\"48-title\"), 0.9, {opacity:0, x:35}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.2, 1);\n        }\n\n        function onPageLeave() {\n          pg48Anim.stop();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 49-sub\" style=\"top:805px;left:252px;\" src=\"/126/static/_content/49-sub-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg49Anim = new TimelineMax();\n          pg49Anim.fromTo(cOf(\"49-sub\"), 0.9, {opacity:0, y:-30}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.4);\n        }\n\n        function onPageLeave() {\n          pg49Anim.stop();\n        }\n      ",
    "searchText": "IN A SERIES OF STRIKING IMAGES, LOCAL PHOTOGRAPHERS SIDY TALLA AND BADARA PREIRA CAPTURE DAKAR’S VIBRANT SPORTING CULTURE AND THE RHYTHMS OF EVERYDAY LIFE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 50-title\" style=\"top:102px;left:46px;\" src=\"/126/static/_content/50-title-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg50Anim = new TimelineMax();\n          pg50Anim.fromTo(cOf(\"50-title\"), 0.9, {opacity:0, x:35}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1);\n        }\n\n        function onPageLeave() {\n          pg50Anim.stop();\n        }\n      ",
    "searchText": "50  Through the lens  MEET THE PHOTOGR APHERS  SIDY TALLA Sidy Talla (cover photograph) is a Senegalese photographer, graphic designer and sound engineer, known for his sporting photography and visual content creation. He is the founder and artistic director of Studio Eyelit, a Dakar-based agency that specialises in photography, visual identity creation and production of communications materials. His artistic approach is to tell stories through his pictures, especially in the world of sports where he is particularly active. Today, Talla is one of the most sought-after sports photographers in Senegal where he collaborates with a variety of organisations and sporting events to capture unforgettable moments.  BADARA PREIRA Senegalese photographer Badara Preira’s work focuses on human beings, memory and contemporary social realities. Aware that photography cannot change the world by itself but can help to open people’s eyes, for several years he has devoted himself to projects involving street children, the homeless and refugees. His sensitive and documentary-style approach has led him to collaborate with several international institutions and organisations, including Greenpeace, the Institut Français de Dakar, CHANEL and the Galerie du 19M, as well as the IOC with whom he ﬁrst collaborated in 2022 on projects related to Dakar 2026 and Senegalese youth.  ST"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "51  ST"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "BP"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ST  ST"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "54  Through the lens  ST"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "BP"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "BP"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "58  Through the lens  BP  BP"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "BP"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "BP  ST"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "61  BP  ST"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 62-title\" style=\"top:143px;left:42px;\" src=\"/126/static/_content/62-title-1.png\"/>\n      <img class=\"abs halfScale 62-sub\" style=\"top:212px;left:43px;\" src=\"/126/static/_content/62-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg62Anim = new TimelineMax();\n          pg62Anim.fromTo(cOf(\"62-title\"), 0.9, {opacity:0, x:35}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"62-sub\"), 0.9, {opacity:0, y:15}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg62Anim.stop();\n        }\n      ",
    "searchText": "62  Beyond the rings  BEYOND THE RINGS  A shared vision Rémy Rioux, outgoing Chief Executive Officer (CEO) of the Agence Française de Développement (AFD) Group, discusses partnering with the IOC to make sport a driver of sustainable development  T  his article, which I have the honour of authoring, is one of my last as CEO of the AFD Group. After 10 years at the helm of our institution, which is at the heart of France’s cooperation and development policy, I am happy to be able to take up my pen here to thank all the IOC and AFD teams who have helped to build this fruitful partnership. The discussions between AFD and the IOC started in 2019 and are inseparable from the Paris 2024 Olympic and Paralympic Games. It was through the COVID-19 pandemic and the preparations for the Games that our institutions became acquainted and began to work together, and mutually revealed that we share the same vision of sport as a powerful catalyst for change for a healthier, more inclusive and more peaceful world. In 2020, AFD and Paris 2024 signed the first ever partnership between an Organising Committee for the Olympic Games and a public development bank to extend the heritage of the Games in time and beyond borders. For Paris 2024, we launched a business incubator to support the entrepreneurial projects of 83 African and French athletes, and funded 45 sport-for-development projects across 19 African countries, then spearheaded increased cooperation between Senegal and France to support the success and legacy of the Dakar 2026 Youth Olympic Games (YOG). Building on the success of this first cooperation with the Olympic Movement, I went to Lausanne in March 2024 to sign an ambitious agreement with then-IOC President Thomas Bach. We wanted  to make this partnership a laboratory for how international sports organisations and development banks can act together for sport, education, peace and sustainable growth. Two concrete projects were born from this collaboration. The first, funded with the Laureus Sport for Good Foundation, aims to promote sport for education and employability in Africa, and has already supported 29 civil society organisations. The second, in four Southeast Asian countries, supports social innovations using sport as a lever to fight against juvenile delinquency and promote the reintegration of young people who are in difficulty with the law. The IOC has also become an active member of the Coalition for Sustainable Development through Sport, which brings together public development banks and international institutions committed to increased investment in sport for development. The implementation of the commitments made at the Sport for Sustainable Development Summit on 25 July 2024, the eve of the Paris 2024 Opening Ceremony, requires an unwavering commitment from the entire international community and the sports movement. The IOC with its Olympism365 strategy, defined by the commission of which I am a proud member, acts as a key partner and plays a leading role – often as a pioneer, opening up spaces for dialogue and joint investments. Strengthening advocacy, producing research to better measure the social impact of sport and supporting financial innovation are some of our shared objectives. The organisation of the  Olympism365 Summit by the IOC in June 2025, which led to the adoption of 45 new commitments representing up to USD 200 million of investments, is a very good example of this. The Dakar 2026 YOG are on the horizon and will be the next key milestone in our partnership. AFD’s partnership with Senegal has led to the modernisation of two of the main competition venues of the Games, as well as the creation of 12 local sporting facilities in Grand Dakar. We are working closely with the IOC and the Dakar 2026 Organising Committee to ensure a lasting legacy for these sporting facilities to give greater access to sport to all, in particular girls and women. I am convinced that this first Olympic event on African soil will be a wonderful celebration and a showcase of the full medal potential of the African continent. One third of the world’s youth will be African by 2030 – soon, hopefully, they will win one third of the Olympic medals as well! I am sure that the shared journey dedicated to sport and development between the IOC and AFD is only just beginning, and that much more can be achieved together with the entire community of public development banks gathered within the Finance in Common (FiCS) movement. We can go faster, higher and stronger together to make sport a driver of sustainable development. ■  An expert in economics and international ﬁnancial institutions, Rémy Rioux has held high-level positions in a career devoted to development and Africa. After serving as chief of staff of the French Economy and Finance Minister, he was appointed Deputy Secretary General of the Ministry of Foreign Affairs and International Development. Rioux headed the AFD from 2016 until 2026."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 64-title\" style=\"top:609px;left:47px;\" src=\"/126/static/_content/64-title-1.png\"/>\n      <img class=\"abs halfScale 64-title\" style=\"top:742px;left:47px;\" src=\"/126/static/_content/64-title-2.png\"/>\n      <img class=\"abs halfScale 64-sub\" style=\"top:515px;left:192px;\" src=\"/126/static/_content/64-sub-1.png\"/>\n\n      <div class=\"addContentLink\" style=\"top:512px;left:189px;width:146px;height:14px;\">  \n        <a href=\"https://www.olympics.com/ioc/news/ioc-announces-olympic-champions-medallists-and-olympians-as-athlete-role-models-for-dakar-2026\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg64Anim = new TimelineMax();\n          pg64Anim.staggerFromTo(cOf(\"64-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1)\n          .fromTo(cOf(\"64-sub\"), 0.9, {opacity:0, y:-20}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg64Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "An Athlete Role Model leads a taekwondo initiation at Buenos Aires 2018.  ATHLETE ROLE MODELS WILL HELP YOUNG COMPETITORS AT DAKAR 2026 NAVIGATE FAR MORE THAN SPORT. THROUGH MENTORSHIP AND SHARED EXPERIENCE, THEY WILL PASS ON THE OLYMPIC VALUES TO A NEW GENERATION  INSPiRiNG THE NEXT GENERATiON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "T  he Youth Olympic Games (YOG) have always been about more than winning medals. While the YOG give young athletes the opportunity to compete on one of sport’s biggest stages, their lasting impact is experience and lessons learned beyond the podium. Since Singapore 2010, the inaugural edition of the YOG, Athlete Role Models have supported and advised the next generations, offering their guidance to complement young athletes’ sporting prowess. Dakar 2026 will be no different. Some 36 Athlete Role Models will be present, representing every competition sport and several engagement sports. Selected by their International Federations, Athlete Role Models will spend the YOG mentoring participants through educational activities, workshops and informal conversations. Beyond offering advice, Athlete Role Models provide something more valuable: perspective. They remind young athletes that their journeys will be shaped not only by results, but also by resilience, responsibility and the example they set for others. If one of the main goals of the YOG is to guide the next generation of athletes, then Athlete Role Models are the ones helping light the way. Over the following pages, Dakar 2026 Athlete Role Models reﬂect on their journeys with Olympic Review. Halimah Nakaayi, Blessing Oborududu, Forrester Osei and Jamila Lunkuse spoke to Conor Ketley, while Ruth Gbagbi, JeanPierre Bourhis and Yves Bourhis shared their stories with SalahEddine Gakou."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 66-title\" style=\"top:197px;left:44px;\" src=\"/126/static/_content/66-title-1.png\"/>\n      <img class=\"abs halfScale 66-sub\" style=\"top:316px;left:43px;\" src=\"/126/static/_content/66-sub-1.png\"/>\n      <img class=\"abs halfScale 66-img\" style=\"top:50px;left:285px;\" src=\"/126/static/_content/66-img-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg66Anim = new TimelineMax();\n          pg66Anim.fromTo(cOf(\"66-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"66-sub\"), 0.9, {opacity:0, y:15}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg66Anim.stop();\n        }\n      ",
    "searchText": "66  Feature: Dakar 2026 Overview  Ugandan world champion runner Halimah Nakaayi shares how persistence, education and the transformative experience of the Youth Olympic Games inspired her rise to the top  I  come from Kampala, in the centre of Uganda, which is the place where Ugandans believe that no great athletes come from. They believe that it’s the people from the mountainous area of the country who are the great runners. My mother was an athlete in school, but I was born when she was just 17 years old, so she did not have a real chance to prove herself. I started running in school at the age of seven, and I’m lucky that my school gave the students a chance to show our talent and compete against other schools. I managed to win two of those inter-school competitions, which gave  Conor Ketley is a sports editor and journalist based in London, United Kingdom. He has worked across multiple editions of the Olympic Games, specialising in communications and storytelling. He also covered the Lausanne 2020 Youth Olympic Games and works across English, French and Spanish.  In Uganda, we used to believe that we were great at long distance but, after I won my gold medal, so many more athletes are performing at the top level in middle distance, too. I think that I broke the negativity and it’s been a transformation in Uganda. It’s been a long journey, but all of it has come out of persistence and consistency.  Treasured memories me the chance to study at a new boarding school. My parents found that they couldn’t afford to pay the new school fees, but my dad insisted. “Halimah, look at our community, look at our region,” he said to me. “We have never had any great athletes. The only way you can make it in life is to study. I’ll accept for you to go to that school on one condition: that you also use this opportunity to study.”  Breaking barriers My dad talked a lot about studies, but my mum supported me strongly, too. She would take me to do hill work and extra running training. Her support really motivated me, but in my mind I thought, “I have to study. I have to use this talent to study.” So when I was at school, I made sure to really concentrate and also work hard in sports. I’m lucky that I’ve passed through all the competitive stages of being an athlete: youth, junior and senior level. But I’ve also been consistent. During all those years, I stayed in school, and in 2018 I graduated from the University of Kampala with a bachelor’s degree in computer science and information technology. It was a journey of sacriﬁce and hard work to balance both sport and academics. Then came the World Athletics Championships in Doha in 2019. No one thought that I could become a world champion, so I feel like I broke barriers.  When I think about Dakar 2026, it brings me back to my experience at the YOG. I took part in the ﬁrst YOG, Singapore 2010, when I was just 15 years old, and this experience changed my life. Staying in an Olympic Village with athletes from so many different countries, all the new food, the drinks – I even received a free smartphone! We didn’t have a smartphone at home back then. The YOG just opened my mind. It was such a unique moment that inspired me to work harder and to keep on representing Uganda so that I wouldn’t miss out on more of these wonderful moments. Since that event, not a single year has passed in which I have not represented my country. Now I have an opportunity to talk to and inspire the young generation. The YOG in Dakar will inspire many, many athletes. Not only those from Uganda or Africa, but worldwide. Sport gives us a platform to link up with so many people around the world and it opens new opportunities. Of course, performance is important, but sport is a blessing in the way it connects us to so many people. ■  1 Nakaayi won gold in the women's 800m event at the World Athletics Championships Doha 2019."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  67  Issue 126  Halimah Nakaayi is a Ugandan middle-distance runner who has represented her country in the women’s 800m at three Olympic Games: Rio 2016, Tokyo 2020 and Paris 2024. Having ﬁrst competed on the Olympic stage at the inaugural YOG in Singapore in 2010, Nakaayi became women’s 800m world champion at the 2019 World Athletics Championships in Doha. Away from the track, she is a member of the World Athletics Athletes’ Commission.  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 68-title\" style=\"top:209px;left:32px;\" src=\"/126/static/_content/68-title-1.png\"/>\n      <img class=\"abs halfScale 68-sub\" style=\"top:330px;left:43px;\" src=\"/126/static/_content/68-sub-1.png\"/>\n      <img class=\"abs halfScale 68-img\" style=\"top:78px;left:386px;\" src=\"/126/static/_content/68-img-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg68Anim = new TimelineMax();\n          pg68Anim.fromTo(cOf(\"68-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"68-sub\"), 0.9, {opacity:0, y:15}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg68Anim.stop();\n        }\n      ",
    "searchText": "68  Feature: Dakar 2026 Overview  Olympic silver medallist and multiple-time African champion in wrestling Blessing Oborududu reﬂects on defying expectations, making Olympic history and why she wants the next generation to go even further  M  y journey has been about hard work, discipline and dedication. I always had this spirit of not giving up, to keep pushing and that where I am in my career is not a barrier: I can achieve anything if I have a clear goal. When I started wrestling, I was just doing it at school for fun. But then, competing at state and national level, I would cry when I lost. Not because I lost the tournament but because of all of my hard work and e!ort. Sometimes, things can happen that weren’t supposed to or you see something in the tournament that you didn’t expect. So, that disappointment made me realise that I had that drive to succeed built in me.  My ﬁrst international outing wasn’t easy – it was my ﬁrst time wrestling others from di!erent countries and they were not like the people you wrestle at home. At those African Championships, I still managed to win bronze, but from the second outing onwards, it was gold medal, gold medal, gold medal. I had competed at previous Olympic Games, but at Tokyo 2020, my silver medal was a scene of joy and a moment I’ll never forget. When I look back and think about where I came from – all the challenges I overcame, all the hard work I put in – it was just an amazing moment. Reaching the ﬁnal was a dream come true; it is a privilege to be able to win medals for my country at the elite level.  Forging my own path  Pushing others even higher  When I was young, my uncle told me that wrestling is not for girls, wrestling is for boys. But I said, “I’ve seen ladies wrestling, so why can’t I do it?” The women who I saw competing were pioneers who didn’t have as much support as us nowadays. Watching them made me feel that I could be like them. I also had people say to me, “Blessing, you are young and you can wrestle, but if you don’t travel abroad and leave Nigeria, you cannot be a champion.” But I told them that I would stay in Nigeria and succeed.  From when I was young, I was always encouraging others. I want to see people grow, which makes it easy to be a coach now. I still have the passion of an athlete and I just want to see other generations and people who can do even better than me. I won a silver medal at the Olympics, but I want to see the people after me win gold. It’s important for young athletes to have a mentor and it’s a privilege for me to be able to be that mentor and inspire them. What gives me joy when working with athletes is that sometimes they’ll come to you and say, “That thing you told me – I did it and it worked!” I hope that I can do that for the young sportsmen and women at Dakar 2026.  1 Oborududu overcomes her semi-ﬁnal opponent on her way to silver in the 68kg category at Tokyo 2020.  And even if they don’t win at the YOG speciﬁcally, with time they will surely succeed. This ﬁrst Olympic sports event in Africa is a very special moment. This means that the continent is growing and we have more opportunity to showcase both our young talent and our culture to the world. ■  Blessing Oborududu is a Nigerian wrestler and one of Africa’s most successful athletes in the sport. A 14-time African champion, she made history at Tokyo 2020 by becoming the ﬁrst Nigerian wrestler to win an Olympic medal, claiming silver in the 68kg category. She has represented Nigeria at four Olympic Games: London 2012, Rio 2016, Tokyo 2020 and Paris 2024."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 70-title\" style=\"top:243px;left:44px;\" src=\"/126/static/_content/70-title-1.png\"/>\n      <img class=\"abs halfScale 70-sub\" style=\"top:316px;left:43px;\" src=\"/126/static/_content/70-sub-1.png\"/>\n      <img class=\"abs halfScale 70-img\" style=\"top:71px;left:294px;\" src=\"/126/static/_content/70-img-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg70Anim = new TimelineMax();\n          pg70Anim.fromTo(cOf(\"70-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"70-sub\"), 0.9, {opacity:0, y:15}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg70Anim.stop();\n        }\n      ",
    "searchText": "70  Feature: Dakar 2026 Overview  Ghanaian weightlifter Forrester Osei reﬂects on the power of role models, the importance of support and why the Dakar 2026 Youth Olympic Games represent a deﬁning moment for young athletes  I  grew up in a household with a big family. My brothers and cousins were around all the time and we all played various sports. One brother in particular always urged me on. He was the one that brought me to my ﬁrst gym session and told me that I had the power and the ability to make my dreams become a possibility. The way others looked at him in our community, how he was respected by people young and old, I believe he was seen as a success for the entire family because he embodied all the good values they wanted to see. He set the path for me to realise that I could do anything. Having him as a role model created a standard that I’ve always wanted to achieve. I believe that it is so important nowadays for the younger generation to have positive role models – to be able to look up and know that they’re doing the right thing, and think that they can set the bar higher.  Why Dakar 2026 matters Dakar 2026 is a historic event that is happening on the continent of my motherland. As soon as I heard about the opportunity to be an Athlete Role Model at the YOG, I reached out straight away. I want to do what I can to make the event successful for the young athletes attending. Weightlifting isn’t part of the competitive programme for the YOG, but an engagement sport so we will run an exhibition show in  Dakar. If any young person or spectator comes to watch and they feel inspired to practise the sport, which has a strong heritage in Africa, for me that would be a huge success. Because that’s what it’s all about: encouraging others to do something they never thought they could. Whatever happens in Dakar, I will walk away with a content heart knowing that whoever I had the opportunity to meet might remember some form of experience with me, even if it’s for a brief moment. Knowing that I am doing something that could add value to someone else’s life is really signiﬁcant to me.  No athlete succeeds alone I played a lot of football when I was younger, which required a lot of strength and conditioning work, and then created an ideal environment for me to transition into weightlifting. From there, I ended up qualifying for the IWF World Weightlifting Championships, then the African Games in Brazzaville, and that was followed by winning a gold medal at the 2016 Commonwealth Weightlifting Championships. The ﬁrst word that comes to mind when I think about my career is grateful. I’m grateful and content with my achievements. There is, of course, more to come with LA28, and I’ll be taking another shot at qualifying for the Olympic Games there, but the gratitude comes from being happy with my career and having the right people along the way supporting me.  A supportive entourage is a very large component of any athlete’s journey, and people outside of sport might not be able to understand how important they are. They help us with the psychological side outside of the gym and training environment and they keep us motivated. Sometimes your sporting journey can be ﬁlled with uncertainty, not knowing if you’re going to win anything and thinking that you might disappoint those that support you. But having those people by your side is uplifting. Now, I have the opportunity to engage with young athletes at Dakar 2026 and to be able to contribute to them in many aspects. With the YOG being a historic event in Africa, it feels right to be involved and helping to shape the next generation. ■  1 Osei believes that Dakar 2026 could be a transformative event for sport in Africa."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Forrester Osei is a Ghanaian weightlifter who has represented his country at major international competitions, including the Commonwealth Games and multiple IWF World Weightlifting Championships. He won gold in the 94kg category at the 2016 Commonwealth Weightlifting Championships in Penang, Malaysia. Osei has also played an inﬂuential role within the International Weightlifting Federation (IWF), serving as Chair of the IWF Athletes’ Commission.  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 72-title\" style=\"top:259px;left:44px;\" src=\"/126/static/_content/72-title-1.png\"/>\n      <img class=\"abs halfScale 72-sub\" style=\"top:330px;left:43px;\" src=\"/126/static/_content/72-sub-1.png\"/>\n      <img class=\"abs halfScale 72-img\" style=\"top:75px;left:380px;\" src=\"/126/static/_content/72-img-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg72Anim = new TimelineMax();\n          pg72Anim.fromTo(cOf(\"72-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"72-sub\"), 0.9, {opacity:0, y:15}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg72Anim.stop();\n        }\n      ",
    "searchText": "72  Feature: Dakar 2026 Overview  Jamila LunkuseÕs story proves that ﬁnding joy in sport is as important as pursuing results, from early friendships in the pool to competing on the Olympic stage  M  y journey started in Kampala, Uganda. I was always a sporty child, and I tried all sorts of sports at school – badminton, basketball, football – but swimming was the one that stuck. It was really my friends that drew me to swimming. At ﬁrst, it was just an excuse to get o! the school grounds, but we were all in the same club and travelled together to di!erent meets. As we got older, training could be long and hard, and being able to bond through that solidiﬁed those friendships.  New horizons At 12 years old, I moved to Plymouth in the UK to study at Plymouth College. That’s where my swimming really developed in terms of training and becoming more structured in my technique. I was boarding only with other swimmers, and I loved the experience. By 15, I had reached my ﬁrst Olympic Games, London 2012. It was so much fun! After my race, I remember just trying to soak it all in, exchanging as many pins as I could and mixing with athletes from di!erent countries. Truthfully, though, I was so young, and I don’t think that I recognised what a big milestone it was for my career at the time. I had developed this mindset of, “OK, what’s next? I can do better.” In that moment, I didn’t stop to appreciate what I’d accomplished. It was only after I had competed at Rio 2016 that I started to understand my achievements. I would hear about another  athlete who had made their second Olympic appearance and think, “Oh yeah, I went to the Olympics!” That’s when I could ﬁnally stop and reﬂect on the fact that I did a lot during my time.  “If they can do it, you can do it” Growing up, I didn’t really have any swimming role models in the traditional sense. I don’t know if it’s because I didn’t really see many swimmers that looked like me, but the athletes that I looked up to were track and ﬁeld athletes like Shelly-Ann Fraser-Pryce and Allyson Felix. I loved their conﬁdence and how much fun they had doing their thing. I also admired Ugandan steeplechase runner Dorcus Inzikuru because she just seemed so happy – before the race she was smiling, and after the race she was smiling. When you have someone who you see yourself in or someone that looks like you achieving really big things, it gives you that hope and belief. If they can do it, you can do it as well. That was so important for me.  Succeeding as an Athlete Role Model For me, the purpose of the YOG is to bring young athletes together from around the world and to encourage participation in sports. I also think that they should have role models that are diverse because everyone has di!erent backgrounds, experiences and  knowledge to o!er. Every athlete wants to be an Olympic medallist – that’s the goal – but not everyone will achieve that. That doesn’t mean that your story isn’t valuable or that sport hasn’t given you amazing things. At Dakar 2026, I just want to be open and engaging, and as present as I can be. I’m not going to have all the answers, but if I can inspire or support just one athlete to keep going or to feel less alone in their journey, I’ll feel like it’s a massive success. As a young athlete, you can go through things and think you’re alone in your experiences. Being a role model puts you in a powerful position to be able to share your story and how you navigated certain situations – which could make the di!erence for someone who might be struggling in silence. These young athletes deserve to understand the magnitude of their achievements. The fact that they’ve been selected to represent their countries at an elite international event means that they’re the best of the best – they deserve to own that. But the most important thing is to enjoy the experience: make friends, exchange pins and take it all in! They will look back on these Games for the rest of their lives. ■  1 Lunkuse wants young athletes to remember how much sport can bring to their lives."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  73  Issue 126  Jamila Lunkuse represented Uganda at the London 2012 and Rio 2016 Olympic Games, as well as at two editions of the Commonwealth Games. She has achieved multiple national records and won bronze medals in both 50m and 100m breaststroke at the 2010 African Youth Games in Rabat, Morocco. Alongside her competitive career, she is also a member of the World Aquatics Athletes’ Committee.  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 74-title\" style=\"top:213px;left:29px;\" src=\"/126/static/_content/74-title-1.png\"/>\n      <img class=\"abs halfScale 74-sub\" style=\"top:333px;left:43px;\" src=\"/126/static/_content/74-sub-1.png\"/>\n      <img class=\"abs halfScale 74-img\" style=\"top:34px;left:267px;\" src=\"/126/static/_content/74-img-1.png\"/>    \n      ",
    "script": "\n        function onPageEnter() {\n          pg74Anim = new TimelineMax();\n          pg74Anim.fromTo(cOf(\"74-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"74-sub\"), 0.9, {opacity:0, y:15}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg74Anim.stop();\n        }\n      ",
    "searchText": "74  Feature: Dakar 2026 Overview  Ruth Gbagbi – Ivorian taekwondo champion, Olympic medallist and now Athlete Role Model for Dakar 2026 – sees this event as a source of pride for the entire continent and an opportunity to pass on her legacy to future generations  The Dakar 2026 Youth Olympic Games will be the ﬁrst Olympic sporting event held in Africa. What does this mean to you? Most of all, it is a source of great pride – for me, for African athletes and more broadly for the whole continent. It is also a very special moment for me because I myself took part in the Singapore 2010 Youth Olympic Games. I know what it means for a young athlete: the people you meet, the conversations you have and everything you learn outside of the competition.  Salah-Eddine Gakou is a Franco-Senegalese journalist and presenter. He works with TV5 MONDE, amongst others. He also acts as a moderator for events and teaches radio in journalism schools. For more than 10 years, he has been covering topics related to international news, sport and youth issues, working between Africa and France.  I think Dakar 2026 could be a real turning point. We’ve already seen that Africa is capable of organising major events, most recently with the Africa Cup of Nations. These Games will show just what the continent is capable of. Do you think this could pave the way for the Olympic Games to be held in Africa in the future? Yes, I do. This type of event can shift mindsets, change perceptions and build conﬁdence. Dakar 2026 could be a signiﬁcant step in this direction. You will be an Athlete Role Model. How do you hope to inﬂuence young people? I want to share my experience and, above all, encourage them to make the most of this opportunity. The Youth Olympic Games aren’t just about the competition; there’s also everything the IOC organises around it – meetings, training and human interactions. These are experiences that can shape a person’s future. When you were the Youth Olympians’ age, how did you see your future? I started sport quite young, and from the age of 10 I was already very focused on my sporting career. Very early on, I wanted to progress and go far. But at that age, you don’t necessarily realise everything that can happen in a career.  Beyond the medals, what has your career taught you? Most importantly, humility and discipline. These are essential values, both in sport and in life. I was lucky enough to be surrounded by people who taught me a great deal and gave me valuable advice. Today, I want to pass this on to younger generations. How do you see today’s African youth? Young Africans are extremely ambitious and creative. You see it in sport, but also in music, in art and on social media. There’s a real energy and a drive to succeed, sometimes right here on the African continent, to ﬂy a ﬂag for Africa. Apart from sport, what are you hoping to discover in Dakar? I want to experience everything Dakar has to o!er. Whether that’s eating the best jollof rice cooked by a Senegalese mama, visiting places, discovering Senegalese culture or even dancing, especially mbalax. Usually, when I go to Senegal, it’s for competitions. This time will be di!erent, so I want to let my hair down a bit and I’m open to all sorts of new experiences. ■  1 Gbagbi won bronze at both Rio 2016 and Tokyo 2020 in the women’s -67kg category in taekwondo."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  75  Issue 126  1  Ruth Gbagbi is an Ivorian taekwondo athlete who made history by winning Côte d’Ivoire’s ﬁrst-ever Olympic medal by a woman when she claimed bronze in the women’s -67kg category at Rio 2016. She went on to compete again at Tokyo 2020, winning another bronze medal in the same weight division. She is also a multiple African champion, and became world champion at the 2017 World Taekwondo Championship in Muju, South Korea, in the -62kg category."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 76-title\" style=\"top:197px;left:29px;\" src=\"/126/static/_content/76-title-1.png\"/>\n      <img class=\"abs halfScale 76-sub\" style=\"top:320px;left:43px;\" src=\"/126/static/_content/76-sub-1.png\"/>\n      <img class=\"abs halfScale 76-img\" style=\"top:25px;left:285px;\" src=\"/126/static/_content/76-img-1.png\"/>\n      <img class=\"abs halfScale 76-img\" style=\"top:62px;left:465px;\" src=\"/126/static/_content/76-img-2.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg76Anim = new TimelineMax();\n          pg76Anim.fromTo(cOf(\"76-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"76-sub\"), 0.9, {opacity:0, y:15}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg76Anim.stop();\n        }\n      ",
    "searchText": "76  Feature: Dakar 2026 Overview  Brothers, Franco-Senegalese, Olympians: Jean-Pierre and Yves Bourhis share the same sport, the same discipline and soon the same role, that of passing on their legacy. Appointed Athlete Role Models for Dakar 2026, the two kayakers open up about pride, resilience and Senegal  Dakar 2026, the Youth Olympic Games (YOG) on the African continent – what does that mean to you? Jean-Pierre: It’s a ﬁrst building block – and for the Games to be held in Senegal, our country, it’s a source of great pride. I think we’ll see the young people we’re going to meet again in the future at the Olympic Games. We hope to see them shine. Yves: We’ve both competed at the Olympic Games. We weren’t lucky enough to take part in the YOG, but being involved in this event in a di!erent way is still a source of great pride. It’s going to be a huge celebration! You’ll be Athlete Role Models: what role do you want to play for the young athletes? Jean-Pierre: I’d like to inspire them in two ways: to become Olympians, but also by showing that these athletes can study and combine sport with a career. I work a bit too hard, and I’d need to work a bit less to perform a bit better. But I see too many athletes giving up because there’s no funding, especially in Africa. We need to ﬁnd alternatives – work part-time, self-fund. There really is a way. Yves: I’d like to pass on resilience to them. Failure is part of the process. I also agree with Jean-Pierre about having a job. At the last Games, I was the only one among the ﬁnalists to have a job. It’s not easy, but it is possible to do it all at the same time.  What difference does it make being brothers in the same sport? Jean-Pierre: We travel together, compete together, train together. We cheer each other on when one of us moves up to the next level; we push each other. In competition, the best one wins, and that’s that. We put our egos aside. Yves: We know each other well – we’re on the same wavelength. And when we’re not competing in the same events, we analyse each other’s performances and give feedback. Otherwise, it would be much more complicated. Canoe slalom is not always very well known among the general public. What would you like people to understand about your sport? Jean-Pierre: That once you’re in this world, it’s actually quite friendly. At races we all know one another, we say hello. It’s a di!erent kind of rivalry from football or tennis. We’re doing sport, but most of all we’re here for the fun of it. And kayaking lets you see the world, discover lovely places. The Youth Olympic Games will give a great taste of that. Yves: Our sport can become better known by being open. You can easily meet the Olympic champions and talk to them. Everyone is approachable.  When I say Dakar, what’s the ﬁrst thing that springs to mind? Jean-Pierre: Making the very most of it. I haven’t been back since 2016. We have family on our mother’s side; sadly, she passed away a few years ago. We’re going to try to reconnect with our cousins, eat the local food – that goes without saying. And then there’s a project I’m running with an organisation that makes composite materials: tables for schools, a pirogue, a locally produced slalom kayak. Projects that have a real local impact. Yves: The ﬁrst thing I’m going to do is have a hearty meal. A yassa or a maafe. I was in Senegal for two weeks last summer, so I know exactly what I’ve been missing. And then a walk to check out the race venues. ■  1 Yves Bourhis completes a run in the men's slalom K1 event at Paris 2024. 2 Jean-Pierre Bourhis ﬁnished 18th in the men's slalom C1 event at Rio 2016."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1  2  Jean-Pierre and Yves Bourhis are FrancoSenegalese canoe slalom athletes and brothers who have both represented Senegal at the Olympic Games. Jean-Pierre competed at Rio 2016 and Tokyo 2020, while Yves represented the country at Paris 2024.  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 78-title\" style=\"top:83px;left:43px;\" src=\"/126/static/_content/78-title-1.png\"/>\n      <img class=\"abs halfScale 78-sub\" style=\"top:148px;left:43px;\" src=\"/126/static/_content/78-sub-1.png\"/>\n\n      <div class=\"addContentLink\" style=\"top:824px;left:172px;width:142px;height:12px\">\n        <a href=\"mailto:studies.centre@olympic.org\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:824px;left:320px;width:115px;height:12px\">\n        <a href=\"https://olympics.com/studies\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:824px;left:440px;width:110px;height:12px\">\n        <a href=\"https://olympics.com/library\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:836px;left:184px;width:115px;height:12px\">\n        <a href=\"https://www.facebook.com/OlympicStudiesCentre/?locale=en_GB\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:836px;left:304px;width:231px;height:12px\">\n        <a href=\"https://www.linkedin.com/showcase/olympic-studies-centre/?originalSubdomain=ch\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:342px;left:43px;width:169px;height:15px;\">  \n        <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3857000/let-s-get-moving-together-a-toolkit-for-grassroots-sport-leaders-international-council-of-sport-sci\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:342px;left:259px;width:179px;height:15px;\">  \n        <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3788749/fast-tracks-and-dark-deals-how-sport-became-business-and-business-became-sport-michael-payne\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:342px;left:475px;width:112px;height:15px;\">  \n        <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3704609/a-games-changer-the-international-olympic-committee-tokyo-2020-and-covid-19-stephen-r-wenn-and-rober\" target=\"_blank\"></a>\n      </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg78Anim = new TimelineMax();\n          pg78Anim.fromTo(cOf(\"78-title\"), 0.9, {opacity:0, x:35}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"78-sub\"), 0.9, {opacity:0, y:15}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg78Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "78  Olympic Studies  OLYMPiC STUDiES The latest book reviews from the IOC Olympic Studies Centre – your source of Olympic knowledge  LET’S GET MOVING TOGETHER!:  FAST TRACKS AND DARK DEALS:  A GAMES CHANGER:  This second edition of the International Council of Sport Science and Physical Education (ICSSPE) toolkit offers practical guidance for practitioners, educators and non-governmental organisations (NGOs) working in grassroots sport and sport for development on how to design, manage and evaluate community programmes. Updated by emerging sports leaders from Namibia, South Africa and Zambia, it reﬂects real-ﬁeld conditions and offers African perspectives on leadership, inclusion, governance and programme delivery. Drawing on their experience in coaching, teaching, community leadership and research, the authors offer a resource that directly addresses the sector’s operational challenges. The toolkit covers key themes such as leadership and empowerment, governance and organisational management, equality and inclusion, partnership development, fundraising and long-term sustainability.  In this autobiography, Michael R. Payne – one of the most inﬂuential ﬁgures in modern sports marketing and former Marketing Director of the IOC – offers an unprecedented look at how global sport has transformed into a major economic force. Drawing on ﬁve decades at the heart of the Olympic Movement and then Formula 1, he combines vivid personal experience with incisive analysis of the political, commercial and strategic forces that transformed international sport. Payne retraces the creation of the IOC’s Worldwide Olympic Partner (TOP) programme, the reinvention of global broadcasting rights and the corporate partnerships that ensured the long-term stability of the Olympic Games. Told from a vantage point “close enough to hear the whispers in the corridor yet distant enough to see the broader patterns”, the book offers a rare insight, concluding with a revealing prediction for the next 50 years.  Scholars Stephen R. Wenn and Robert K. Barney explore a pivotal moment in Olympic history: the postponement of the Tokyo 2020 Olympic Games. Drawing on extensive sources, including media coverage and interviews with IOC officials, they reveal the behind-the-scenes decision-making during the global pandemic. Faced with health risks, political pressures, economic stakes and logistical challenges, Japanese Prime Minister Abe Shinzo and IOC President Thomas Bach made the historic choice to reschedule rather than cancel the Games. More than just a chronicle, the book offers an interesting reﬂection on how the Olympic Movement can adapt to global challenges. An essential read for those interested in sport governance, crisis management and the enduring spirit of the Olympic Games.  A TOOLKIT FOR GRASSROOTS SPORT LEADERS  HOW SPORT BECAME BUSINESS AND BUSINESS BECAME SPORT  PUBLiSHED BY: ICSSPE, 2025, 88 pages,  WRITTEN BY: Michael R. Payne PUBLiSHED BY: Chiselbury Publishing, 2025,  in English.  9781916556751, 585 pages, in English.  THE INTERNATIONAL OLYMPIC COMMITTEE, TOKYO 2020 & COVID-19  WRITTEN BY: Stephen R. Wenn, Robert K. Barney. PUBLiSHED BY: The University of Arkansas Press, 2025, 9781682262764, 258 pages, in English.  FIND OUT MORE For historical, factual information and research, library resources or information about our academic network and programmes, contact us and visit our Olympic World Library: studies.centre@olympic.org olympics.com/studies olympics.com/library OlympicStudiesCentre linkedin.com/showcase/olympic-studies-centre"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Zero distractions when it matters the most Through seamless technology integration, we’re helping the IOC keep the spotlight where it belongs—on the athletes.  Nour Elhouda Ettaieb OLY Rowing, Tunisia Consultant, Deloitte US Nanjing 2014; Rio 2016; Tokyo 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 80-title\" style=\"top:107px;left:43px;\" src=\"/126/static/_content/80-title-1.png\"/>\n      <img class=\"abs halfScale 80-sub\" style=\"top:165px;left:43px;\" src=\"/126/static/_content/80-sub-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg80Anim = new TimelineMax();\n          pg80Anim.fromTo(cOf(\"80-title\"), 0.9, {opacity:0, x:35}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"80-sub\"), 0.9, {opacity:0, y:10}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg80Anim.stop();\n        }\n      ",
    "searchText": "80  Obituaries  OBITUARIES  We remember Olympians and ﬁ gures from the Olympic Movement who have passed away  SiR CRAiG REEDiE Former IOC Vice-President who played a central role in the ﬁght against doping  MELiTÓN SÁNCHEZ RiVAS  Sir Craig Reedie, IOC Honorary Member and a leading ﬁgure in international sports administration, has passed away at the age of 84. A former international badminton player, he went on to play a central role in the Olympic Movement, serving as Chair of the British Olympic Association from 1992 to 2005 and as an IOC Member from 1994, including a term as Vice-President between 2012 and 2016. Reedie was instrumental in securing badminton’s inclusion in the Olympic sports programme for Barcelona 1992 and played a key part in London’s successful bid to host the Olympic Games in 2012. He also served as President of the World Anti-Doping Agency from 2014 to 2019 and was awarded the Olympic Order in 2023 for his distinguished service to sport.  Melitón Sánchez Rivas, IOC Honorary Member and a leading ﬁgure in sport in Panama and the Americas, has passed away at the age of 91. A former baseball and softball player, he dedicated much of his life to sports administration, serving as President of the Panamanian National Olympic Committee (NOC) from 1982 to 2007, after earlier holding the role of Treasurer. Elected as an IOC Member in 1998, he served until 2014 and was subsequently named an Honorary Member. Sánchez Rivas was awarded the Olympic Order in 2014 for his contributions to the Olympic Movement.  WiLLiAM THORESSON  STEVE CLARK  William Thoresson, the Swedish Olympic gymnastics champion, has died at the age of 93. Thoresson won gold in the men’s ﬂoor exercise at Helsinki 1952, becoming Sweden’s ﬁrst and so far only Olympic gold medallist in gymnastics, and added silver in the same event at Melbourne 1956. Competing at four Olympic Games between 1952 and 1964, he also won bronze on ﬂoor at the 1954 World Championships. Thoresson was inducted into the International Gymnastics Hall of Fame in 2001 for his contributions to the sport.  Steve Clark, a three-time Olympic swimming gold medallist for the United States, has passed away at the age of 82. A freestyle specialist, he competed at Rome 1960 before winning three men’s relay gold medals at Tokyo 1964 in the 4 × 100m freestyle, 4 × 200m freestyle and 4 × 100m medley. Each of those victories came in a world record time. Clark also won 100m freestyle gold at the 1963 Pan American Games. He was inducted into the International Swimming Hall of Fame in 1966.  MARiAN KASPRZYK Marian Kasprzyk, the Polish Olympic boxing gold medallist, has passed away at the age of 86. Kasprzyk won gold in the men’s welterweight division at Tokyo 1964, having previously claimed bronze as a light welterweight at Rome 1960. He also competed at Mexico 1968."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  81  Issue 126  RAJA RANDHiR SiNGH  UNG CHANG  Raja Randhir Singh, a ﬁve-time Olympian and IOC Honorary Member, has passed away at the age of 79. As a trap and skeet shooter, he represented India at ﬁve editions of the Olympic Games, from Mexico 1968 to Los Angeles 1984. Elected as an IOC Member in 2001, he served until 2014 and was subsequently named an Honorary Member. Singh also served as Secretary General of the Indian Olympic Association for nearly three decades, helping to shape Indian sport at national and international levels.  IOC Honorary Member whose actions and diplomacy highlighted the power of promoting dialogue through sport Professor Ung Chang, IOC Honorary Member and a central ﬁgure in sport on the Korean peninsula, has died at the age of 87. A former basketball international who captained the Democratic People’s Republic of Korea (DPRK) national team, he later devoted his career to sports administration, serving as Secretary General and Vice-President of the DPRK NOC and as Vice-President of the Olympic Council of Asia. Elected as an IOC Member in 1996, he became his country’s sole representative within the organisation and was later named an Honorary Member. Chang played a key role in promoting dialogue through sport, notably contributing to the historic joint marches of the DPRK and the Republic of Korea at the Opening Ceremonies of Sydney 2000 and PyeongChang 2018.  FRANCO MENiCHELLi Franco Menichelli, Italy’s ﬁve-time Olympic gymnastics medallist, has died at the age of 84. Menichelli won gold on the ﬂoor at Tokyo 1964, where he also claimed silver on the rings and bronze on the parallel bars, adding to the two bronze medals he had earned at Rome 1960 in the team and ﬂoor events. One of the pioneers of modern ﬂoor exercise, Menichelli also won six European titles, including the all-around crown in 1965, and three World Championship bronze medals. He later coached the Italian men’s national team following his retirement from competition.  DAViNDER SiNGH GARCHA Davinder Singh Garcha, an Olympic hockey gold medallist with India, has passed away at the age of 73. He was a member of the Indian team that won gold at Moscow 1980, scoring eight goals across six matches as India secured its record eighth Olympic title in men’s hockey by defeating Spain 4-3 in the gold medal match.  RONNiE DELANY Ronnie Delany, the Irish Olympic athletics gold medallist, has died at the age of 91. Delany won gold in the men’s 1,500m at Melbourne 1956, producing a late surge to claim victory in an Olympic record time. In doing so, he became the ﬁrst Irishman to win Olympic gold in athletics since 1932. Delany went on to win bronze in the 1,500m at the 1958 European Athletics Championships and also competed at Rome 1960.  MARY RAND Mary Rand, Great Britain’s ﬁrst female Olympic athletics champion, has passed away at the age of 86. She made history at Tokyo 1964 by winning gold in the women’s long jump with a leap of 6.76m, setting a world record and becoming the ﬁrst British woman to win an Olympic track and ﬁeld gold medal. At the same Games, she also won silver in the pentathlon and bronze in the 4 × 100m relay, making her the ﬁrst British female to win three medals at a single edition of the Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 82-title\" style=\"top:83px;left:43px;\" src=\"/126/static/_content/82-title-1.png\"/>\n      <img class=\"abs halfScale 82-sub\" style=\"top:172px;left:50px;\" src=\"/126/static/_content/82-sub-1.png\"/>\n\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:257px;left:103px; font-size: 7.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 1}' ></h1>\n      <img class=\"abs halfScale 82-title\" style=\"top:284px;left:131px;\" src=\"/126/static/_content/82-text-1.png\"/>\n\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:463px;left:134px; font-size: 4.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 50}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:612px;left:190px; font-size: 4.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 4}' ></h1>\n\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:250px;left:469px; font-size: 4.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 14}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:354px;left:532px; font-size: 4.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 153}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:481px;left:402px; font-size: 4.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 2700, \"comma\" : true}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:477px;left:594px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 5000, \"comma\" : true}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:513px;left:533px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 200}' ></h1>\n\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:641px;left:512px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 263}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:641px;left:603px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 29}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:691px;left:343px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 900000, \"comma\" : true}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:746px;left:333px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 11000, \"comma\" : true}' ></h1>\n\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:766px;left:445px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 3, \"comma\" : true}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:800px;left:499px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 8, \"comma\" : true}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:816px;left:574px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 1, \"comma\" : true}' ></h1>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg82Anim = new TimelineMax();\n          pg82Anim.staggerFromTo(cOf(\"82-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.5, 1)\n          .fromTo(cOf(\"82-sub\"), 0.9, {opacity:0, y:25}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3)\n          .fromTo(cOf(\"82-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[0])}}, 1.3)\n          .fromTo(cOf(\"82-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[1])}}, 1.3)\n          .fromTo(cOf(\"82-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[2])}}, 1.3)\n          .fromTo(cOf(\"82-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[3])}}, 1.5)\n          .fromTo(cOf(\"82-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[4])}}, 1.5)\n          .fromTo(cOf(\"82-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[5])}}, 1.5)\n          .fromTo(cOf(\"82-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[6])}}, 1.5)\n          .fromTo(cOf(\"82-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[7])}}, 1.5)\n          .fromTo(cOf(\"82-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[8])}}, 1.7)\n          .fromTo(cOf(\"82-no\")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[9])}}, 1.7)\n          .fromTo(cOf(\"82-no\")[10], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[10])}}, 1.7)\n          .fromTo(cOf(\"82-no\")[11], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[11])}}, 1.7)\n          .fromTo(cOf(\"82-no\")[12], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[12])}}, 1.9)\n          .fromTo(cOf(\"82-no\")[13], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[13])}}, 1.9)\n          .fromTo(cOf(\"82-no\")[14], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[14])}}, 1.9)\n        }\n\n        function onPageLeave() {\n          pg82Anim.stop();\n          resetNumbers(\"82-no\");\n        }\n      ",
    "searchText": "82  The last word  YOUNG AT HEART Olympic Review looks at the numbers behind the fourth edition of the Summer Youth Olympic Games  1  14  ST  31 October – 13 November 2026 25 competition sports 10 engagement sports  153  Olympic sporting event to be held in Africa YOG to include the participation of a Youth Refugee Olympic Team YOG to achieve full gender equality across athlete quotas, disciplines and events  50  %  2,700 200+  male and female athletes  medal events 73 men’s events 73 women’s events 7 mixed events  5,000+ volunteers  National Olympic Committees  athletes  Boxing, gymnastics and wrestling to reach gender parity for the first time at an Olympic Games  4  days of competition  Dakar Learning Academy  sports to make their Olympic debuts Baseball5 Beach wrestling Coastal rowing Wushu  263  Brevet olympique civique et sportif education programme  Learners  29  nationalities  900,000  children to be reached  11,000 schools  3  host cities Dakar, Diamniadio, Saly  8  competition venues  1  Youth Olympic Village"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n\n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n\n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'addContentLink'\n        })\n      }\n\n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'addContentLinkThree'\n        })\n      }\n\n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLinkThree'\n        })\n      }\n\n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n\n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function animateNumbers(klass, delay = 1, stagger = 0.3) {\n        numbers = cOf(klass)\n\n        setTimeout(function() {\n          for (let i = 0; i < numbers.length; i++) {\n            setTimeout(animateNumber, stagger * 1000 * i, numbers[i])\n          }\n        }, delay * 1000)\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function individualGallery(index) {\n        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 60;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-VB7EE37DYS" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "OLkq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OT+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Om6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WpSr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fbGF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hIWI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hxKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l+EB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lsaJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o4GY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJNA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.8c3e863f626e33f44d07.js